(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["alma-tokens"] = {}));
})(this, (function (exports) { 'use strict';

	/**
	 * Do not edit directly
	 * Generated on Fri, 18 Feb 2022 15:26:43 GMT
	 */
	const BorderRadiusNone$3 = "0px";
	const BorderRadiusXs$3 = "4px";
	const BorderRadiusSm$3 = "8px";
	const BorderRadiusMd$3 = "16px";
	const BorderRadiusLg$3 = "24px";
	const BorderRadiusPill$3 = "960px";
	const BorderRadiusCircle$3 = "50%";
	const BorderWidthNone$3 = "0px";
	const BorderWidthHairline$3 = "1px";
	const BorderWidthThin$3 = "2px";
	const BorderWidthThick$3 = "4px";
	const BorderWidthHeavy$3 = "8px";
	const ColorDatavizNegativeText$3 = "#960012";
	const ColorDatavizNegativeShape01$3 = "#DA3347";
	const ColorDatavizNegativeShape02$3 = "#FFCCD2";
	const ColorDatavizNegativeShape03$3 = "#FFEDEF";
	const ColorDatavizPositiveText$3 = "#145528";
	const ColorDatavizPositiveShape01$3 = "#38BA5F";
	const ColorDatavizPositiveShape02$3 = "#C9EFD5";
	const ColorDatavizPositiveShape03$3 = "#EAF9EF";
	const ColorDatavizInverseNegativeText$3 = "#FFCCD2";
	const ColorDatavizInverseNegativeShape01$3 = "#F66778";
	const ColorDatavizInverseNegativeShape02$3 = "#AD1426";
	const ColorDatavizInverseNegativeShape03$3 = "#960012";
	const ColorDatavizInversePositiveText$3 = "#C9EFD5";
	const ColorDatavizInversePositiveShape01$3 = "#59D37E";
	const ColorDatavizInversePositiveShape02$3 = "#228340";
	const ColorDatavizInversePositiveShape03$3 = "#145528";
	const ColorInteractionBlend01$3 = "#1616160A";
	const ColorInteractionBlend02$3 = "#16161614";
	const ColorInteractionBlend03$3 = "#1616161F";
	const ColorInteractionBlend04$3 = "#1616163D";
	const ColorInteractionBlend05$3 = "#161616A3";
	const ColorInteractionBlend06$3 = "#161616B8";
	const ColorInteractionBlend07$3 = "#161616E0";
	const ColorInteractionBlend08$3 = "#161616";
	const ColorInteractionInverseBlend01$3 = "#FEFEFE14";
	const ColorInteractionInverseBlend02$3 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03$3 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04$3 = "#FEFEFE52";
	const ColorInteractionInverseBlend05$3 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06$3 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07$3 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08$3 = "#FEFEFE";
	const ColorInteractionInverseAccent01$3 = "#BE99EE";
	const ColorInteractionInverseAccent02$3 = "#D2B8F3";
	const ColorInteractionInverseAccent03$3 = "#E5D7F8";
	const ColorInteractionInverseSubtle01$3 = "#BE99EE1F";
	const ColorInteractionInverseSubtle02$3 = "#BE99EE3D";
	const ColorInteractionInverseSubtle03$3 = "#BE99EE52";
	const ColorInteractionInverseSelectDefault$3 = "#CCCCCC";
	const ColorInteractionInverseSelectFocus$3 = "#FEFEFE";
	const ColorInteractionInverseSelectActive$3 = "#E5D7F8";
	const ColorInteractionInverseDanger01$3 = "#F66778";
	const ColorInteractionInverseDanger02$3 = "#FF96A2";
	const ColorInteractionInverseDanger03$3 = "#FFCCD2";
	const ColorInteractionInverseOnBrandAccent01$3 = "#161616";
	const ColorInteractionInverseOnBrandAccent02$3 = "#161616E8";
	const ColorInteractionInverseOnBrandAccent03$3 = "#161616B8";
	const ColorInteractionInverseOnBrandSubtle01$3 = "#16161614";
	const ColorInteractionInverseOnBrandSubtle02$3 = "#1616161F";
	const ColorInteractionInverseOnBrandSubtle03$3 = "#1616163D";
	const ColorInteractionInverseOnBrandSelectDefault$3 = "#161616";
	const ColorInteractionInverseOnBrandSelectFocus$3 = "#161616";
	const ColorInteractionInverseOnBrandSelectActive$3 = "#161616";
	const ColorInteractionInverseOnBrandBlend01$3 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02$3 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03$3 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04$3 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05$3 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06$3 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07$3 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08$3 = "#161616";
	const ColorInteractionInverseOnBrandDanger01$3 = "#161616";
	const ColorInteractionInverseOnBrandDanger02$3 = "#161616E0";
	const ColorInteractionInverseOnBrandDanger03$3 = "#161616B8";
	const ColorInteractionAccent01$3 = "#833BDF";
	const ColorInteractionAccent02$3 = "#7A38CF";
	const ColorInteractionAccent03$3 = "#6932AF";
	const ColorInteractionSubtle01$3 = "#833BDF1F";
	const ColorInteractionSubtle02$3 = "#833BDF3D";
	const ColorInteractionSubtle03$3 = "#833BDF52";
	const ColorInteractionSelectDefault$3 = "#4B4B4B";
	const ColorInteractionSelectFocus$3 = "#161616";
	const ColorInteractionSelectActive$3 = "#6932AF";
	const ColorInteractionDanger01$3 = "#DA3347";
	const ColorInteractionDanger02$3 = "#C62336";
	const ColorInteractionDanger03$3 = "#AD1426";
	const ColorInteractionOnBrandAccent01$3 = "#FEFEFE";
	const ColorInteractionOnBrandAccent02$3 = "#FEFEFEE0";
	const ColorInteractionOnBrandAccent03$3 = "#FEFEFEB8";
	const ColorInteractionOnBrandSubtle01$3 = "#FEFEFE1F";
	const ColorInteractionOnBrandSubtle02$3 = "#FEFEFE3D";
	const ColorInteractionOnBrandSubtle03$3 = "#FEFEFE52";
	const ColorInteractionOnBrandSelectDefault$3 = "#FEFEFE";
	const ColorInteractionOnBrandSelectFocus$3 = "#FEFEFE";
	const ColorInteractionOnBrandSelectActive$3 = "#FEFEFE";
	const ColorInteractionOnBrandBlend01$3 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02$3 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03$3 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04$3 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05$3 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06$3 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07$3 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08$3 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01$3 = "#FEFEFE";
	const ColorInteractionOnBrandDanger02$3 = "#FEFEFEE0";
	const ColorInteractionOnBrandDanger03$3 = "#FEFEFEB8";
	const ColorNeutral10$3 = "#F4F4F4";
	const ColorNeutral20$3 = "#E9E9E9";
	const ColorNeutral30$3 = "#1616161F";
	const ColorNeutral00$3 = "#FEFEFE";
	const ColorNeutralInverse10$3 = "#2B2B2B";
	const ColorNeutralInverse20$3 = "#323232";
	const ColorNeutralInverse30$3 = "#FEFEFE3D";
	const ColorNeutralInverse00$3 = "#161616";
	const ColorNeutralInverseOnBrand10$3 = "#572C8F";
	const ColorNeutralInverseOnBrand20$3 = "#6932AF";
	const ColorNeutralInverseOnBrand30$3 = "#833BDFE0";
	const ColorNeutralInverseOnBrand00$3 = "#161616";
	const ColorNeutralOnBrand10$3 = "#EFE7FA";
	const ColorNeutralOnBrand20$3 = "#E5D7F8";
	const ColorNeutralOnBrand30$3 = "#BE99EEE0";
	const ColorNeutralOnBrand00$3 = "#FEFEFE";
	const ColorPaletteBlack$3 = "#161616";
	const ColorPaletteWhite$3 = "#FEFEFE";
	const ColorPaletteGray10$3 = "#2B2B2B";
	const ColorPaletteGray20$3 = "#323232";
	const ColorPaletteGray30$3 = "#4B4B4B";
	const ColorPaletteGray40$3 = "#606060";
	const ColorPaletteGray50$3 = "#B6B6B6";
	const ColorPaletteGray60$3 = "#CCCCCC";
	const ColorPaletteGray70$3 = "#E9E9E9";
	const ColorPaletteGray80$3 = "#F4F4F4";
	const ColorPaletteRed10$3 = "#960012";
	const ColorPaletteRed20$3 = "#AD1426";
	const ColorPaletteRed30$3 = "#C62336";
	const ColorPaletteRed40$3 = "#DA3347";
	const ColorPaletteRed50$3 = "#F66778";
	const ColorPaletteRed60$3 = "#FF96A2";
	const ColorPaletteRed70$3 = "#FFCCD2";
	const ColorPaletteRed80$3 = "#FFEDEF";
	const ColorPalettePurple10$3 = "#610F8A";
	const ColorPalettePurple20$3 = "#8214B8";
	const ColorPalettePurple30$3 = "#9818D9";
	const ColorPalettePurple40$3 = "#A93BDF";
	const ColorPalettePurple50$3 = "#C871F4";
	const ColorPalettePurple60$3 = "#DB9EFA";
	const ColorPalettePurple70$3 = "#EFD0FF";
	const ColorPalettePurple80$3 = "#FAF0FF";
	const ColorPaletteGreen10$3 = "#145528";
	const ColorPaletteGreen20$3 = "#228340";
	const ColorPaletteGreen30$3 = "#2DA853";
	const ColorPaletteGreen40$3 = "#38BA5F";
	const ColorPaletteGreen50$3 = "#59D37E";
	const ColorPaletteGreen60$3 = "#8AE3A5";
	const ColorPaletteGreen70$3 = "#C9EFD5";
	const ColorPaletteGreen80$3 = "#EAF9EF";
	const ColorPaletteYellow10$3 = "#8A6C0F";
	const ColorPaletteYellow20$3 = "#B88F14";
	const ColorPaletteYellow30$3 = "#E6B319";
	const ColorPaletteYellow40$3 = "#EBC247";
	const ColorPaletteYellow50$3 = "#F0D275";
	const ColorPaletteYellow60$3 = "#F5E1A3";
	const ColorPaletteYellow70$3 = "#FAF0D1";
	const ColorPaletteYellow80$3 = "#FDF8E8";
	const ColorTypefaceStrong$3 = "#161616";
	const ColorTypefacePure$3 = "#323232";
	const ColorTypefaceSmooth$3 = "#4B4B4B";
	const ColorTypefaceMeld$3 = "#1616163D";
	const ColorTypefaceInverseStrong$3 = "#FEFEFE";
	const ColorTypefaceInversePure$3 = "#E9E9E9";
	const ColorTypefaceInverseSmooth$3 = "#CCCCCC";
	const ColorTypefaceInverseMeld$3 = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong$3 = "#161616";
	const ColorTypefaceInverseOnBrandPure$3 = "#161616E0";
	const ColorTypefaceInverseOnBrandSmooth$3 = "#161616B8";
	const ColorTypefaceInverseOnBrandMeld$3 = "#1616163D";
	const ColorTypefaceOnBrandStrong$3 = "#FEFEFE";
	const ColorTypefaceOnBrandPure$3 = "#FEFEFEE0";
	const ColorTypefaceOnBrandSmooth$3 = "#FEFEFEB8";
	const ColorTypefaceOnBrandMeld$3 = "#FEFEFE52";
	const ColorBrandPrimary10$3 = "#572C8F";
	const ColorBrandPrimary20$3 = "#6932AF";
	const ColorBrandPrimary30$3 = "#7A38CF";
	const ColorBrandPrimary40$3 = "#833BDF";
	const ColorBrandPrimary50$3 = "#BE99EE";
	const ColorBrandPrimary60$3 = "#D2B8F3";
	const ColorBrandPrimary70$3 = "#E5D7F8";
	const ColorBrandPrimary80$3 = "#EFE7FA";
	const ColorFeedbackErrorText$3 = "#960012";
	const ColorFeedbackErrorShape$3 = "#DA3347";
	const ColorFeedbackSuccessText$3 = "#145528";
	const ColorFeedbackSuccessShape$3 = "#38BA5F";
	const ColorFeedbackOnBrandErrorText$3 = "#FEFEFE";
	const ColorFeedbackOnBrandErrorShape$3 = "#FEFEFEB8";
	const ColorFeedbackOnBrandSuccessText$3 = "#FEFEFE";
	const ColorFeedbackOnBrandSuccessShape$3 = "#FEFEFEB8";
	const ColorFeedbackInverseErrorText$3 = "#FFCCD2";
	const ColorFeedbackInverseErrorShape$3 = "#F66778";
	const ColorFeedbackInverseSuccessText$3 = "#C9EFD5";
	const ColorFeedbackInverseSuccessShape$3 = "#59D37E";
	const ColorFeedbackInverseOnBrandErrorText$3 = "#161616";
	const ColorFeedbackInverseOnBrandErrorShape$3 = "#161616B8";
	const ColorFeedbackInverseOnBrandSuccessText$3 = "#161616";
	const ColorFeedbackInverseOnBrandSuccessShape$3 = "#161616B8";
	const ColorSupport01$3 = "#F358AC";
	const ColorSupport02$3 = "#E1479A";
	const ColorSupportOnBrand01$3 = "#FF9ED3";
	const ColorSupportOnBrand02$3 = "#FFC2DB";
	const ColorSupportInverse01$3 = "#FF6FBD";
	const ColorSupportInverse02$3 = "#FF6FBD";
	const ColorSupportInverseOnBrand01$3 = "#9F2868";
	const ColorSupportInverseOnBrand02$3 = "#8F245D";
	const Opacity01$3 = "0.04";
	const Opacity02$3 = "0.08";
	const Opacity03$3 = "0.12";
	const Opacity04$3 = "0.24";
	const Opacity05$3 = "0.32";
	const Opacity06$3 = "0.56";
	const Opacity07$3 = "0.64";
	const Opacity08$3 = "0.72";
	const Opacity09$3 = "0.88";
	const Shadow01$3 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02$3 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03$3 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04$3 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark$3 = "4px";
	const SpacingInlineNano$3 = "8px";
	const SpacingInlineXxxs$3 = "16px";
	const SpacingInlineXxs$3 = "24px";
	const SpacingInlineXs$3 = "32px";
	const SpacingInlineSm$3 = "40px";
	const SpacingInlineMd$3 = "48px";
	const SpacingInlineLg$3 = "56px";
	const SpacingInlineXl$3 = "64px";
	const SpacingInlineXxl$3 = "80px";
	const SpacingInlineXxxl$3 = "120px";
	const SpacingInlineHuge$3 = "160px";
	const SpacingInlineGiant$3 = "200px";
	const SpacingInsetQuark$3 = "4px";
	const SpacingInsetNano$3 = "8px";
	const SpacingInsetXs$3 = "16px";
	const SpacingInsetSm$3 = "24px";
	const SpacingInsetMd$3 = "32px";
	const SpacingInsetLg$3 = "40px";
	const SpacingSquishQuark$3 = "4px 8px";
	const SpacingSquishNano$3 = "8px 16px";
	const SpacingSquishXs$3 = "16px 24px";
	const SpacingSquishSm$3 = "16px 32px";
	const SpacingStackQuark$3 = "4px";
	const SpacingStackNano$3 = "8px";
	const SpacingStackXxxs$3 = "16px";
	const SpacingStackXxs$3 = "24px";
	const SpacingStackXs$3 = "32px";
	const SpacingStackSm$3 = "40px";
	const SpacingStackMd$3 = "48px";
	const SpacingStackLg$3 = "56px";
	const SpacingStackXl$3 = "64px";
	const SpacingStackXxl$3 = "80px";
	const SpacingStackXxxl$3 = "120px";
	const SpacingStackHuge$3 = "160px";
	const SpacingStackGiant$3 = "200px";
	const FontFamilyBase$3 = "'Dasa Sans', sans-serif";
	const FontSizeXxxs$3 = "0.75rem";
	const FontSizeXxs$3 = "0.875rem";
	const FontSizeXs$3 = "1rem";
	const FontSizeSm$3 = "1.25rem";
	const FontSizeMd$3 = "1.5rem";
	const FontSizeLg$3 = "2rem";
	const FontSizeXl$3 = "2.5rem";
	const FontSizeXxl$3 = "3rem";
	const FontSizeXxxl$3 = "4rem";
	const FontSizeDisplay$3 = "5rem";
	const FontSizeGiant$3 = "6rem";
	const FontWeightBold$3 = 700;
	const FontWeightSemibold$3 = 600;
	const FontWeightMedium$3 = 500;
	const FontWeightRegular$3 = 400;
	const FontWeightLight$3 = 300;
	const LetterSpacingStandard$3 = "0px";
	const LetterSpacingSmall$3 = "-1px";
	const LetterSpacingMedium$3 = "1.5px";
	const LineHeightStandard$3 = "100%";
	const LineHeightTiny$3 = "115%";
	const LineHeightMedium$3 = "120%";
	const LineHeightLarge$3 = "125%";
	const LineHeightDistant$3 = "133%";
	const LineHeightSuperdistant$3 = "150%";
	const LineHeightHuge$3 = "170%";

	var index$3 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone$3,
		BorderRadiusXs: BorderRadiusXs$3,
		BorderRadiusSm: BorderRadiusSm$3,
		BorderRadiusMd: BorderRadiusMd$3,
		BorderRadiusLg: BorderRadiusLg$3,
		BorderRadiusPill: BorderRadiusPill$3,
		BorderRadiusCircle: BorderRadiusCircle$3,
		BorderWidthNone: BorderWidthNone$3,
		BorderWidthHairline: BorderWidthHairline$3,
		BorderWidthThin: BorderWidthThin$3,
		BorderWidthThick: BorderWidthThick$3,
		BorderWidthHeavy: BorderWidthHeavy$3,
		ColorDatavizNegativeText: ColorDatavizNegativeText$3,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$3,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$3,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$3,
		ColorDatavizPositiveText: ColorDatavizPositiveText$3,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$3,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$3,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$3,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$3,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$3,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$3,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$3,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$3,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$3,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$3,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$3,
		ColorInteractionBlend01: ColorInteractionBlend01$3,
		ColorInteractionBlend02: ColorInteractionBlend02$3,
		ColorInteractionBlend03: ColorInteractionBlend03$3,
		ColorInteractionBlend04: ColorInteractionBlend04$3,
		ColorInteractionBlend05: ColorInteractionBlend05$3,
		ColorInteractionBlend06: ColorInteractionBlend06$3,
		ColorInteractionBlend07: ColorInteractionBlend07$3,
		ColorInteractionBlend08: ColorInteractionBlend08$3,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$3,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$3,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$3,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$3,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$3,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$3,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$3,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$3,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$3,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$3,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$3,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$3,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$3,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$3,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$3,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$3,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$3,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$3,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$3,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$3,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$3,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$3,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$3,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$3,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$3,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$3,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$3,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$3,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$3,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$3,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$3,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$3,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$3,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$3,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$3,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$3,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$3,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$3,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$3,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$3,
		ColorInteractionAccent01: ColorInteractionAccent01$3,
		ColorInteractionAccent02: ColorInteractionAccent02$3,
		ColorInteractionAccent03: ColorInteractionAccent03$3,
		ColorInteractionSubtle01: ColorInteractionSubtle01$3,
		ColorInteractionSubtle02: ColorInteractionSubtle02$3,
		ColorInteractionSubtle03: ColorInteractionSubtle03$3,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault$3,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus$3,
		ColorInteractionSelectActive: ColorInteractionSelectActive$3,
		ColorInteractionDanger01: ColorInteractionDanger01$3,
		ColorInteractionDanger02: ColorInteractionDanger02$3,
		ColorInteractionDanger03: ColorInteractionDanger03$3,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$3,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$3,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$3,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$3,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$3,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$3,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$3,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$3,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$3,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$3,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$3,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$3,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$3,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$3,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$3,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$3,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$3,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$3,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$3,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$3,
		ColorNeutral10: ColorNeutral10$3,
		ColorNeutral20: ColorNeutral20$3,
		ColorNeutral30: ColorNeutral30$3,
		ColorNeutral00: ColorNeutral00$3,
		ColorNeutralInverse10: ColorNeutralInverse10$3,
		ColorNeutralInverse20: ColorNeutralInverse20$3,
		ColorNeutralInverse30: ColorNeutralInverse30$3,
		ColorNeutralInverse00: ColorNeutralInverse00$3,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$3,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$3,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$3,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$3,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10$3,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20$3,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30$3,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00$3,
		ColorPaletteBlack: ColorPaletteBlack$3,
		ColorPaletteWhite: ColorPaletteWhite$3,
		ColorPaletteGray10: ColorPaletteGray10$3,
		ColorPaletteGray20: ColorPaletteGray20$3,
		ColorPaletteGray30: ColorPaletteGray30$3,
		ColorPaletteGray40: ColorPaletteGray40$3,
		ColorPaletteGray50: ColorPaletteGray50$3,
		ColorPaletteGray60: ColorPaletteGray60$3,
		ColorPaletteGray70: ColorPaletteGray70$3,
		ColorPaletteGray80: ColorPaletteGray80$3,
		ColorPaletteRed10: ColorPaletteRed10$3,
		ColorPaletteRed20: ColorPaletteRed20$3,
		ColorPaletteRed30: ColorPaletteRed30$3,
		ColorPaletteRed40: ColorPaletteRed40$3,
		ColorPaletteRed50: ColorPaletteRed50$3,
		ColorPaletteRed60: ColorPaletteRed60$3,
		ColorPaletteRed70: ColorPaletteRed70$3,
		ColorPaletteRed80: ColorPaletteRed80$3,
		ColorPalettePurple10: ColorPalettePurple10$3,
		ColorPalettePurple20: ColorPalettePurple20$3,
		ColorPalettePurple30: ColorPalettePurple30$3,
		ColorPalettePurple40: ColorPalettePurple40$3,
		ColorPalettePurple50: ColorPalettePurple50$3,
		ColorPalettePurple60: ColorPalettePurple60$3,
		ColorPalettePurple70: ColorPalettePurple70$3,
		ColorPalettePurple80: ColorPalettePurple80$3,
		ColorPaletteGreen10: ColorPaletteGreen10$3,
		ColorPaletteGreen20: ColorPaletteGreen20$3,
		ColorPaletteGreen30: ColorPaletteGreen30$3,
		ColorPaletteGreen40: ColorPaletteGreen40$3,
		ColorPaletteGreen50: ColorPaletteGreen50$3,
		ColorPaletteGreen60: ColorPaletteGreen60$3,
		ColorPaletteGreen70: ColorPaletteGreen70$3,
		ColorPaletteGreen80: ColorPaletteGreen80$3,
		ColorPaletteYellow10: ColorPaletteYellow10$3,
		ColorPaletteYellow20: ColorPaletteYellow20$3,
		ColorPaletteYellow30: ColorPaletteYellow30$3,
		ColorPaletteYellow40: ColorPaletteYellow40$3,
		ColorPaletteYellow50: ColorPaletteYellow50$3,
		ColorPaletteYellow60: ColorPaletteYellow60$3,
		ColorPaletteYellow70: ColorPaletteYellow70$3,
		ColorPaletteYellow80: ColorPaletteYellow80$3,
		ColorTypefaceStrong: ColorTypefaceStrong$3,
		ColorTypefacePure: ColorTypefacePure$3,
		ColorTypefaceSmooth: ColorTypefaceSmooth$3,
		ColorTypefaceMeld: ColorTypefaceMeld$3,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$3,
		ColorTypefaceInversePure: ColorTypefaceInversePure$3,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$3,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$3,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$3,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$3,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$3,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$3,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$3,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$3,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$3,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$3,
		ColorBrandPrimary10: ColorBrandPrimary10$3,
		ColorBrandPrimary20: ColorBrandPrimary20$3,
		ColorBrandPrimary30: ColorBrandPrimary30$3,
		ColorBrandPrimary40: ColorBrandPrimary40$3,
		ColorBrandPrimary50: ColorBrandPrimary50$3,
		ColorBrandPrimary60: ColorBrandPrimary60$3,
		ColorBrandPrimary70: ColorBrandPrimary70$3,
		ColorBrandPrimary80: ColorBrandPrimary80$3,
		ColorFeedbackErrorText: ColorFeedbackErrorText$3,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape$3,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText$3,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$3,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$3,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$3,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$3,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$3,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$3,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$3,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$3,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$3,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$3,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$3,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$3,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$3,
		ColorSupport01: ColorSupport01$3,
		ColorSupport02: ColorSupport02$3,
		ColorSupportOnBrand01: ColorSupportOnBrand01$3,
		ColorSupportOnBrand02: ColorSupportOnBrand02$3,
		ColorSupportInverse01: ColorSupportInverse01$3,
		ColorSupportInverse02: ColorSupportInverse02$3,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$3,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$3,
		Opacity01: Opacity01$3,
		Opacity02: Opacity02$3,
		Opacity03: Opacity03$3,
		Opacity04: Opacity04$3,
		Opacity05: Opacity05$3,
		Opacity06: Opacity06$3,
		Opacity07: Opacity07$3,
		Opacity08: Opacity08$3,
		Opacity09: Opacity09$3,
		Shadow01: Shadow01$3,
		Shadow02: Shadow02$3,
		Shadow03: Shadow03$3,
		Shadow04: Shadow04$3,
		SpacingInlineQuark: SpacingInlineQuark$3,
		SpacingInlineNano: SpacingInlineNano$3,
		SpacingInlineXxxs: SpacingInlineXxxs$3,
		SpacingInlineXxs: SpacingInlineXxs$3,
		SpacingInlineXs: SpacingInlineXs$3,
		SpacingInlineSm: SpacingInlineSm$3,
		SpacingInlineMd: SpacingInlineMd$3,
		SpacingInlineLg: SpacingInlineLg$3,
		SpacingInlineXl: SpacingInlineXl$3,
		SpacingInlineXxl: SpacingInlineXxl$3,
		SpacingInlineXxxl: SpacingInlineXxxl$3,
		SpacingInlineHuge: SpacingInlineHuge$3,
		SpacingInlineGiant: SpacingInlineGiant$3,
		SpacingInsetQuark: SpacingInsetQuark$3,
		SpacingInsetNano: SpacingInsetNano$3,
		SpacingInsetXs: SpacingInsetXs$3,
		SpacingInsetSm: SpacingInsetSm$3,
		SpacingInsetMd: SpacingInsetMd$3,
		SpacingInsetLg: SpacingInsetLg$3,
		SpacingSquishQuark: SpacingSquishQuark$3,
		SpacingSquishNano: SpacingSquishNano$3,
		SpacingSquishXs: SpacingSquishXs$3,
		SpacingSquishSm: SpacingSquishSm$3,
		SpacingStackQuark: SpacingStackQuark$3,
		SpacingStackNano: SpacingStackNano$3,
		SpacingStackXxxs: SpacingStackXxxs$3,
		SpacingStackXxs: SpacingStackXxs$3,
		SpacingStackXs: SpacingStackXs$3,
		SpacingStackSm: SpacingStackSm$3,
		SpacingStackMd: SpacingStackMd$3,
		SpacingStackLg: SpacingStackLg$3,
		SpacingStackXl: SpacingStackXl$3,
		SpacingStackXxl: SpacingStackXxl$3,
		SpacingStackXxxl: SpacingStackXxxl$3,
		SpacingStackHuge: SpacingStackHuge$3,
		SpacingStackGiant: SpacingStackGiant$3,
		FontFamilyBase: FontFamilyBase$3,
		FontSizeXxxs: FontSizeXxxs$3,
		FontSizeXxs: FontSizeXxs$3,
		FontSizeXs: FontSizeXs$3,
		FontSizeSm: FontSizeSm$3,
		FontSizeMd: FontSizeMd$3,
		FontSizeLg: FontSizeLg$3,
		FontSizeXl: FontSizeXl$3,
		FontSizeXxl: FontSizeXxl$3,
		FontSizeXxxl: FontSizeXxxl$3,
		FontSizeDisplay: FontSizeDisplay$3,
		FontSizeGiant: FontSizeGiant$3,
		FontWeightBold: FontWeightBold$3,
		FontWeightSemibold: FontWeightSemibold$3,
		FontWeightMedium: FontWeightMedium$3,
		FontWeightRegular: FontWeightRegular$3,
		FontWeightLight: FontWeightLight$3,
		LetterSpacingStandard: LetterSpacingStandard$3,
		LetterSpacingSmall: LetterSpacingSmall$3,
		LetterSpacingMedium: LetterSpacingMedium$3,
		LineHeightStandard: LineHeightStandard$3,
		LineHeightTiny: LineHeightTiny$3,
		LineHeightMedium: LineHeightMedium$3,
		LineHeightLarge: LineHeightLarge$3,
		LineHeightDistant: LineHeightDistant$3,
		LineHeightSuperdistant: LineHeightSuperdistant$3,
		LineHeightHuge: LineHeightHuge$3
	});

	/**
	 * Do not edit directly
	 * Generated on Fri, 18 Feb 2022 15:26:43 GMT
	 */
	const BorderRadiusNone$2 = "0px";
	const BorderRadiusXs$2 = "4px";
	const BorderRadiusSm$2 = "8px";
	const BorderRadiusMd$2 = "16px";
	const BorderRadiusLg$2 = "24px";
	const BorderRadiusPill$2 = "960px";
	const BorderRadiusCircle$2 = "50%";
	const BorderWidthNone$2 = "0px";
	const BorderWidthHairline$2 = "1px";
	const BorderWidthThin$2 = "2px";
	const BorderWidthThick$2 = "4px";
	const BorderWidthHeavy$2 = "8px";
	const ColorDatavizNegativeText$2 = "#960012";
	const ColorDatavizNegativeShape01$2 = "#DA3347";
	const ColorDatavizNegativeShape02$2 = "#FFCCD2";
	const ColorDatavizNegativeShape03$2 = "#FFEDEF";
	const ColorDatavizPositiveText$2 = "#145528";
	const ColorDatavizPositiveShape01$2 = "#38BA5F";
	const ColorDatavizPositiveShape02$2 = "#C9EFD5";
	const ColorDatavizPositiveShape03$2 = "#EAF9EF";
	const ColorDatavizInverseNegativeText$2 = "#FFCCD2";
	const ColorDatavizInverseNegativeShape01$2 = "#F66778";
	const ColorDatavizInverseNegativeShape02$2 = "#AD1426";
	const ColorDatavizInverseNegativeShape03$2 = "#960012";
	const ColorDatavizInversePositiveText$2 = "#C9EFD5";
	const ColorDatavizInversePositiveShape01$2 = "#59D37E";
	const ColorDatavizInversePositiveShape02$2 = "#228340";
	const ColorDatavizInversePositiveShape03$2 = "#145528";
	const ColorInteractionBlend01$2 = "#1616160A";
	const ColorInteractionBlend02$2 = "#16161614";
	const ColorInteractionBlend03$2 = "#1616161F";
	const ColorInteractionBlend04$2 = "#1616163D";
	const ColorInteractionBlend05$2 = "#161616A3";
	const ColorInteractionBlend06$2 = "#161616B8";
	const ColorInteractionBlend07$2 = "#161616E0";
	const ColorInteractionBlend08$2 = "#161616";
	const ColorInteractionInverseBlend01$2 = "#FEFEFE14";
	const ColorInteractionInverseBlend02$2 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03$2 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04$2 = "#FEFEFE52";
	const ColorInteractionInverseBlend05$2 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06$2 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07$2 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08$2 = "#FEFEFE";
	const ColorInteractionInverseAccent01$2 = "#7A819B";
	const ColorInteractionInverseAccent02$2 = "#A2A8BA";
	const ColorInteractionInverseAccent03$2 = "#CBCED8";
	const ColorInteractionInverseSubtle01$2 = "#7A829B1F";
	const ColorInteractionInverseSubtle02$2 = "#7A829B3D";
	const ColorInteractionInverseSubtle03$2 = "#7A829B52";
	const ColorInteractionInverseSelectDefault$2 = "#CCCCCC";
	const ColorInteractionInverseSelectFocus$2 = "#FEFEFE";
	const ColorInteractionInverseSelectActive$2 = "#CBCED8";
	const ColorInteractionInverseDanger01$2 = "#F66778";
	const ColorInteractionInverseDanger02$2 = "#FF96A2";
	const ColorInteractionInverseDanger03$2 = "#FFCCD2";
	const ColorInteractionInverseOnBrandAccent01$2 = "#161616";
	const ColorInteractionInverseOnBrandAccent02$2 = "#161616E8";
	const ColorInteractionInverseOnBrandAccent03$2 = "#161616B8";
	const ColorInteractionInverseOnBrandSubtle01$2 = "#16161614";
	const ColorInteractionInverseOnBrandSubtle02$2 = "#1616161F";
	const ColorInteractionInverseOnBrandSubtle03$2 = "#1616163D";
	const ColorInteractionInverseOnBrandSelectDefault$2 = "#161616";
	const ColorInteractionInverseOnBrandSelectFocus$2 = "#161616";
	const ColorInteractionInverseOnBrandSelectActive$2 = "#161616";
	const ColorInteractionInverseOnBrandBlend01$2 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02$2 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03$2 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04$2 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05$2 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06$2 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07$2 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08$2 = "#161616";
	const ColorInteractionInverseOnBrandDanger01$2 = "#161616";
	const ColorInteractionInverseOnBrandDanger02$2 = "#161616E0";
	const ColorInteractionInverseOnBrandDanger03$2 = "#161616B8";
	const ColorInteractionAccent01$2 = "#000E40";
	const ColorInteractionAccent02$2 = "#000D3B";
	const ColorInteractionAccent03$2 = "#000B31";
	const ColorInteractionSubtle01$2 = "#000E401F";
	const ColorInteractionSubtle02$2 = "#000E403D";
	const ColorInteractionSubtle03$2 = "#000E4052";
	const ColorInteractionSelectDefault$2 = "#4B4B4B";
	const ColorInteractionSelectFocus$2 = "#161616";
	const ColorInteractionSelectActive$2 = "#000B31";
	const ColorInteractionDanger01$2 = "#DA3347";
	const ColorInteractionDanger02$2 = "#C62336";
	const ColorInteractionDanger03$2 = "#AD1426";
	const ColorInteractionOnBrandAccent01$2 = "#FEFEFE";
	const ColorInteractionOnBrandAccent02$2 = "#FEFEFEE0";
	const ColorInteractionOnBrandAccent03$2 = "#FEFEFEB8";
	const ColorInteractionOnBrandSubtle01$2 = "#FEFEFE1F";
	const ColorInteractionOnBrandSubtle02$2 = "#FEFEFE3D";
	const ColorInteractionOnBrandSubtle03$2 = "#FEFEFE52";
	const ColorInteractionOnBrandSelectDefault$2 = "#FEFEFE";
	const ColorInteractionOnBrandSelectFocus$2 = "#FEFEFE";
	const ColorInteractionOnBrandSelectActive$2 = "#FEFEFE";
	const ColorInteractionOnBrandBlend01$2 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02$2 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03$2 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04$2 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05$2 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06$2 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07$2 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08$2 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01$2 = "#FEFEFE";
	const ColorInteractionOnBrandDanger02$2 = "#FEFEFEE0";
	const ColorInteractionOnBrandDanger03$2 = "#FEFEFEB8";
	const ColorNeutral10$2 = "#F4F4F4";
	const ColorNeutral20$2 = "#E9E9E9";
	const ColorNeutral30$2 = "#1616161F";
	const ColorNeutral00$2 = "#FEFEFE";
	const ColorNeutralInverse10$2 = "#2B2B2B";
	const ColorNeutralInverse20$2 = "#323232";
	const ColorNeutralInverse30$2 = "#FEFEFE3D";
	const ColorNeutralInverse00$2 = "#161616";
	const ColorNeutralInverseOnBrand10$2 = "#000826";
	const ColorNeutralInverseOnBrand20$2 = "#000B31";
	const ColorNeutralInverseOnBrand30$2 = "#000E4052";
	const ColorNeutralInverseOnBrand00$2 = "#161616";
	const ColorNeutralOnBrand10$2 = "#DFE1E7";
	const ColorNeutralOnBrand20$2 = "#CBCED8";
	const ColorNeutralOnBrand30$2 = "#7A819BE0";
	const ColorNeutralOnBrand00$2 = "#FEFEFE";
	const ColorPaletteBlack$2 = "#161616";
	const ColorPaletteWhite$2 = "#FEFEFE";
	const ColorPaletteGray10$2 = "#2B2B2B";
	const ColorPaletteGray20$2 = "#323232";
	const ColorPaletteGray30$2 = "#4B4B4B";
	const ColorPaletteGray40$2 = "#606060";
	const ColorPaletteGray50$2 = "#B6B6B6";
	const ColorPaletteGray60$2 = "#CCCCCC";
	const ColorPaletteGray70$2 = "#E9E9E9";
	const ColorPaletteGray80$2 = "#F4F4F4";
	const ColorPaletteRed10$2 = "#960012";
	const ColorPaletteRed20$2 = "#AD1426";
	const ColorPaletteRed30$2 = "#C62336";
	const ColorPaletteRed40$2 = "#DA3347";
	const ColorPaletteRed50$2 = "#F66778";
	const ColorPaletteRed60$2 = "#FF96A2";
	const ColorPaletteRed70$2 = "#FFCCD2";
	const ColorPaletteRed80$2 = "#FFEDEF";
	const ColorPalettePurple10$2 = "#610F8A";
	const ColorPalettePurple20$2 = "#8214B8";
	const ColorPalettePurple30$2 = "#9818D9";
	const ColorPalettePurple40$2 = "#A93BDF";
	const ColorPalettePurple50$2 = "#C871F4";
	const ColorPalettePurple60$2 = "#DB9EFA";
	const ColorPalettePurple70$2 = "#EFD0FF";
	const ColorPalettePurple80$2 = "#FAF0FF";
	const ColorPaletteGreen10$2 = "#145528";
	const ColorPaletteGreen20$2 = "#228340";
	const ColorPaletteGreen30$2 = "#2DA853";
	const ColorPaletteGreen40$2 = "#38BA5F";
	const ColorPaletteGreen50$2 = "#59D37E";
	const ColorPaletteGreen60$2 = "#8AE3A5";
	const ColorPaletteGreen70$2 = "#C9EFD5";
	const ColorPaletteGreen80$2 = "#EAF9EF";
	const ColorPaletteYellow10$2 = "#8A6C0F";
	const ColorPaletteYellow20$2 = "#B88F14";
	const ColorPaletteYellow30$2 = "#E6B319";
	const ColorPaletteYellow40$2 = "#EBC247";
	const ColorPaletteYellow50$2 = "#F0D275";
	const ColorPaletteYellow60$2 = "#F5E1A3";
	const ColorPaletteYellow70$2 = "#FAF0D1";
	const ColorPaletteYellow80$2 = "#FDF8E8";
	const ColorTypefaceStrong$2 = "#161616";
	const ColorTypefacePure$2 = "#323232";
	const ColorTypefaceSmooth$2 = "#4B4B4B";
	const ColorTypefaceMeld$2 = "#1616163D";
	const ColorTypefaceInverseStrong$2 = "#FEFEFE";
	const ColorTypefaceInversePure$2 = "#E9E9E9";
	const ColorTypefaceInverseSmooth$2 = "#CCCCCC";
	const ColorTypefaceInverseMeld$2 = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong$2 = "#161616";
	const ColorTypefaceInverseOnBrandPure$2 = "#161616E0";
	const ColorTypefaceInverseOnBrandSmooth$2 = "#161616B8";
	const ColorTypefaceInverseOnBrandMeld$2 = "#1616163D";
	const ColorTypefaceOnBrandStrong$2 = "#FEFEFE";
	const ColorTypefaceOnBrandPure$2 = "#FEFEFEE0";
	const ColorTypefaceOnBrandSmooth$2 = "#FEFEFEB8";
	const ColorTypefaceOnBrandMeld$2 = "#FEFEFE52";
	const ColorBrandPrimary10$2 = "#000826";
	const ColorBrandPrimary20$2 = "#000B31";
	const ColorBrandPrimary30$2 = "#000D3B";
	const ColorBrandPrimary40$2 = "#000E40";
	const ColorBrandPrimary50$2 = "#7A819B";
	const ColorBrandPrimary60$2 = "#A2A8BA";
	const ColorBrandPrimary70$2 = "#CBCED8";
	const ColorBrandPrimary80$2 = "#DFE1E7";
	const ColorFeedbackErrorText$2 = "#960012";
	const ColorFeedbackErrorShape$2 = "#DA3347";
	const ColorFeedbackSuccessText$2 = "#145528";
	const ColorFeedbackSuccessShape$2 = "#38BA5F";
	const ColorFeedbackOnBrandErrorText$2 = "#FEFEFE";
	const ColorFeedbackOnBrandErrorShape$2 = "#FEFEFEB8";
	const ColorFeedbackOnBrandSuccessText$2 = "#FEFEFE";
	const ColorFeedbackOnBrandSuccessShape$2 = "#FEFEFEB8";
	const ColorFeedbackInverseErrorText$2 = "#FFCCD2";
	const ColorFeedbackInverseErrorShape$2 = "#F66778";
	const ColorFeedbackInverseSuccessText$2 = "#C9EFD5";
	const ColorFeedbackInverseSuccessShape$2 = "#59D37E";
	const ColorFeedbackInverseOnBrandErrorText$2 = "#161616";
	const ColorFeedbackInverseOnBrandErrorShape$2 = "#161616B8";
	const ColorFeedbackInverseOnBrandSuccessText$2 = "#161616";
	const ColorFeedbackInverseOnBrandSuccessShape$2 = "#161616B8";
	const ColorSupport01$2 = "#FF4E33";
	const ColorSupport02$2 = "#EC4A31";
	const ColorSupportOnBrand01$2 = "#ABE6FF";
	const ColorSupportOnBrand02$2 = "#ABE6FF";
	const ColorSupportInverse01$2 = "#ABE6FF";
	const ColorSupportInverse02$2 = "#ABE6FF";
	const ColorSupportInverseOnBrand01$2 = "#000E40";
	const ColorSupportInverseOnBrand02$2 = "#000E40";
	const Opacity01$2 = "0.04";
	const Opacity02$2 = "0.08";
	const Opacity03$2 = "0.12";
	const Opacity04$2 = "0.24";
	const Opacity05$2 = "0.32";
	const Opacity06$2 = "0.56";
	const Opacity07$2 = "0.64";
	const Opacity08$2 = "0.72";
	const Opacity09$2 = "0.88";
	const Shadow01$2 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02$2 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03$2 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04$2 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark$2 = "4px";
	const SpacingInlineNano$2 = "8px";
	const SpacingInlineXxxs$2 = "16px";
	const SpacingInlineXxs$2 = "24px";
	const SpacingInlineXs$2 = "32px";
	const SpacingInlineSm$2 = "40px";
	const SpacingInlineMd$2 = "48px";
	const SpacingInlineLg$2 = "56px";
	const SpacingInlineXl$2 = "64px";
	const SpacingInlineXxl$2 = "80px";
	const SpacingInlineXxxl$2 = "120px";
	const SpacingInlineHuge$2 = "160px";
	const SpacingInlineGiant$2 = "200px";
	const SpacingInsetQuark$2 = "4px";
	const SpacingInsetNano$2 = "8px";
	const SpacingInsetXs$2 = "16px";
	const SpacingInsetSm$2 = "24px";
	const SpacingInsetMd$2 = "32px";
	const SpacingInsetLg$2 = "40px";
	const SpacingSquishQuark$2 = "4px 8px";
	const SpacingSquishNano$2 = "8px 16px";
	const SpacingSquishXs$2 = "16px 24px";
	const SpacingSquishSm$2 = "16px 32px";
	const SpacingStackQuark$2 = "4px";
	const SpacingStackNano$2 = "8px";
	const SpacingStackXxxs$2 = "16px";
	const SpacingStackXxs$2 = "24px";
	const SpacingStackXs$2 = "32px";
	const SpacingStackSm$2 = "40px";
	const SpacingStackMd$2 = "48px";
	const SpacingStackLg$2 = "56px";
	const SpacingStackXl$2 = "64px";
	const SpacingStackXxl$2 = "80px";
	const SpacingStackXxxl$2 = "120px";
	const SpacingStackHuge$2 = "160px";
	const SpacingStackGiant$2 = "200px";
	const FontFamilyBase$2 = "'Dasa Sans', sans-serif";
	const FontSizeXxxs$2 = "0.75rem";
	const FontSizeXxs$2 = "0.875rem";
	const FontSizeXs$2 = "1rem";
	const FontSizeSm$2 = "1.25rem";
	const FontSizeMd$2 = "1.5rem";
	const FontSizeLg$2 = "2rem";
	const FontSizeXl$2 = "2.5rem";
	const FontSizeXxl$2 = "3rem";
	const FontSizeXxxl$2 = "4rem";
	const FontSizeDisplay$2 = "5rem";
	const FontSizeGiant$2 = "6rem";
	const FontWeightBold$2 = 700;
	const FontWeightSemibold$2 = 600;
	const FontWeightMedium$2 = 500;
	const FontWeightRegular$2 = 400;
	const FontWeightLight$2 = 300;
	const LetterSpacingStandard$2 = "0px";
	const LetterSpacingSmall$2 = "-1px";
	const LetterSpacingMedium$2 = "1.5px";
	const LineHeightStandard$2 = "100%";
	const LineHeightTiny$2 = "115%";
	const LineHeightMedium$2 = "120%";
	const LineHeightLarge$2 = "125%";
	const LineHeightDistant$2 = "133%";
	const LineHeightSuperdistant$2 = "150%";
	const LineHeightHuge$2 = "170%";

	var index$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone$2,
		BorderRadiusXs: BorderRadiusXs$2,
		BorderRadiusSm: BorderRadiusSm$2,
		BorderRadiusMd: BorderRadiusMd$2,
		BorderRadiusLg: BorderRadiusLg$2,
		BorderRadiusPill: BorderRadiusPill$2,
		BorderRadiusCircle: BorderRadiusCircle$2,
		BorderWidthNone: BorderWidthNone$2,
		BorderWidthHairline: BorderWidthHairline$2,
		BorderWidthThin: BorderWidthThin$2,
		BorderWidthThick: BorderWidthThick$2,
		BorderWidthHeavy: BorderWidthHeavy$2,
		ColorDatavizNegativeText: ColorDatavizNegativeText$2,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$2,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$2,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$2,
		ColorDatavizPositiveText: ColorDatavizPositiveText$2,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$2,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$2,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$2,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$2,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$2,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$2,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$2,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$2,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$2,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$2,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$2,
		ColorInteractionBlend01: ColorInteractionBlend01$2,
		ColorInteractionBlend02: ColorInteractionBlend02$2,
		ColorInteractionBlend03: ColorInteractionBlend03$2,
		ColorInteractionBlend04: ColorInteractionBlend04$2,
		ColorInteractionBlend05: ColorInteractionBlend05$2,
		ColorInteractionBlend06: ColorInteractionBlend06$2,
		ColorInteractionBlend07: ColorInteractionBlend07$2,
		ColorInteractionBlend08: ColorInteractionBlend08$2,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$2,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$2,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$2,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$2,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$2,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$2,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$2,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$2,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$2,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$2,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$2,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$2,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$2,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$2,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$2,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$2,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$2,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$2,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$2,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$2,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$2,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$2,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$2,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$2,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$2,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$2,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$2,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$2,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$2,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$2,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$2,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$2,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$2,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$2,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$2,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$2,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$2,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$2,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$2,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$2,
		ColorInteractionAccent01: ColorInteractionAccent01$2,
		ColorInteractionAccent02: ColorInteractionAccent02$2,
		ColorInteractionAccent03: ColorInteractionAccent03$2,
		ColorInteractionSubtle01: ColorInteractionSubtle01$2,
		ColorInteractionSubtle02: ColorInteractionSubtle02$2,
		ColorInteractionSubtle03: ColorInteractionSubtle03$2,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault$2,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus$2,
		ColorInteractionSelectActive: ColorInteractionSelectActive$2,
		ColorInteractionDanger01: ColorInteractionDanger01$2,
		ColorInteractionDanger02: ColorInteractionDanger02$2,
		ColorInteractionDanger03: ColorInteractionDanger03$2,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$2,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$2,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$2,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$2,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$2,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$2,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$2,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$2,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$2,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$2,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$2,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$2,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$2,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$2,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$2,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$2,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$2,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$2,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$2,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$2,
		ColorNeutral10: ColorNeutral10$2,
		ColorNeutral20: ColorNeutral20$2,
		ColorNeutral30: ColorNeutral30$2,
		ColorNeutral00: ColorNeutral00$2,
		ColorNeutralInverse10: ColorNeutralInverse10$2,
		ColorNeutralInverse20: ColorNeutralInverse20$2,
		ColorNeutralInverse30: ColorNeutralInverse30$2,
		ColorNeutralInverse00: ColorNeutralInverse00$2,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$2,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$2,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$2,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$2,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10$2,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20$2,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30$2,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00$2,
		ColorPaletteBlack: ColorPaletteBlack$2,
		ColorPaletteWhite: ColorPaletteWhite$2,
		ColorPaletteGray10: ColorPaletteGray10$2,
		ColorPaletteGray20: ColorPaletteGray20$2,
		ColorPaletteGray30: ColorPaletteGray30$2,
		ColorPaletteGray40: ColorPaletteGray40$2,
		ColorPaletteGray50: ColorPaletteGray50$2,
		ColorPaletteGray60: ColorPaletteGray60$2,
		ColorPaletteGray70: ColorPaletteGray70$2,
		ColorPaletteGray80: ColorPaletteGray80$2,
		ColorPaletteRed10: ColorPaletteRed10$2,
		ColorPaletteRed20: ColorPaletteRed20$2,
		ColorPaletteRed30: ColorPaletteRed30$2,
		ColorPaletteRed40: ColorPaletteRed40$2,
		ColorPaletteRed50: ColorPaletteRed50$2,
		ColorPaletteRed60: ColorPaletteRed60$2,
		ColorPaletteRed70: ColorPaletteRed70$2,
		ColorPaletteRed80: ColorPaletteRed80$2,
		ColorPalettePurple10: ColorPalettePurple10$2,
		ColorPalettePurple20: ColorPalettePurple20$2,
		ColorPalettePurple30: ColorPalettePurple30$2,
		ColorPalettePurple40: ColorPalettePurple40$2,
		ColorPalettePurple50: ColorPalettePurple50$2,
		ColorPalettePurple60: ColorPalettePurple60$2,
		ColorPalettePurple70: ColorPalettePurple70$2,
		ColorPalettePurple80: ColorPalettePurple80$2,
		ColorPaletteGreen10: ColorPaletteGreen10$2,
		ColorPaletteGreen20: ColorPaletteGreen20$2,
		ColorPaletteGreen30: ColorPaletteGreen30$2,
		ColorPaletteGreen40: ColorPaletteGreen40$2,
		ColorPaletteGreen50: ColorPaletteGreen50$2,
		ColorPaletteGreen60: ColorPaletteGreen60$2,
		ColorPaletteGreen70: ColorPaletteGreen70$2,
		ColorPaletteGreen80: ColorPaletteGreen80$2,
		ColorPaletteYellow10: ColorPaletteYellow10$2,
		ColorPaletteYellow20: ColorPaletteYellow20$2,
		ColorPaletteYellow30: ColorPaletteYellow30$2,
		ColorPaletteYellow40: ColorPaletteYellow40$2,
		ColorPaletteYellow50: ColorPaletteYellow50$2,
		ColorPaletteYellow60: ColorPaletteYellow60$2,
		ColorPaletteYellow70: ColorPaletteYellow70$2,
		ColorPaletteYellow80: ColorPaletteYellow80$2,
		ColorTypefaceStrong: ColorTypefaceStrong$2,
		ColorTypefacePure: ColorTypefacePure$2,
		ColorTypefaceSmooth: ColorTypefaceSmooth$2,
		ColorTypefaceMeld: ColorTypefaceMeld$2,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$2,
		ColorTypefaceInversePure: ColorTypefaceInversePure$2,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$2,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$2,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$2,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$2,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$2,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$2,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$2,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$2,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$2,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$2,
		ColorBrandPrimary10: ColorBrandPrimary10$2,
		ColorBrandPrimary20: ColorBrandPrimary20$2,
		ColorBrandPrimary30: ColorBrandPrimary30$2,
		ColorBrandPrimary40: ColorBrandPrimary40$2,
		ColorBrandPrimary50: ColorBrandPrimary50$2,
		ColorBrandPrimary60: ColorBrandPrimary60$2,
		ColorBrandPrimary70: ColorBrandPrimary70$2,
		ColorBrandPrimary80: ColorBrandPrimary80$2,
		ColorFeedbackErrorText: ColorFeedbackErrorText$2,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape$2,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText$2,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$2,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$2,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$2,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$2,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$2,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$2,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$2,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$2,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$2,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$2,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$2,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$2,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$2,
		ColorSupport01: ColorSupport01$2,
		ColorSupport02: ColorSupport02$2,
		ColorSupportOnBrand01: ColorSupportOnBrand01$2,
		ColorSupportOnBrand02: ColorSupportOnBrand02$2,
		ColorSupportInverse01: ColorSupportInverse01$2,
		ColorSupportInverse02: ColorSupportInverse02$2,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$2,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$2,
		Opacity01: Opacity01$2,
		Opacity02: Opacity02$2,
		Opacity03: Opacity03$2,
		Opacity04: Opacity04$2,
		Opacity05: Opacity05$2,
		Opacity06: Opacity06$2,
		Opacity07: Opacity07$2,
		Opacity08: Opacity08$2,
		Opacity09: Opacity09$2,
		Shadow01: Shadow01$2,
		Shadow02: Shadow02$2,
		Shadow03: Shadow03$2,
		Shadow04: Shadow04$2,
		SpacingInlineQuark: SpacingInlineQuark$2,
		SpacingInlineNano: SpacingInlineNano$2,
		SpacingInlineXxxs: SpacingInlineXxxs$2,
		SpacingInlineXxs: SpacingInlineXxs$2,
		SpacingInlineXs: SpacingInlineXs$2,
		SpacingInlineSm: SpacingInlineSm$2,
		SpacingInlineMd: SpacingInlineMd$2,
		SpacingInlineLg: SpacingInlineLg$2,
		SpacingInlineXl: SpacingInlineXl$2,
		SpacingInlineXxl: SpacingInlineXxl$2,
		SpacingInlineXxxl: SpacingInlineXxxl$2,
		SpacingInlineHuge: SpacingInlineHuge$2,
		SpacingInlineGiant: SpacingInlineGiant$2,
		SpacingInsetQuark: SpacingInsetQuark$2,
		SpacingInsetNano: SpacingInsetNano$2,
		SpacingInsetXs: SpacingInsetXs$2,
		SpacingInsetSm: SpacingInsetSm$2,
		SpacingInsetMd: SpacingInsetMd$2,
		SpacingInsetLg: SpacingInsetLg$2,
		SpacingSquishQuark: SpacingSquishQuark$2,
		SpacingSquishNano: SpacingSquishNano$2,
		SpacingSquishXs: SpacingSquishXs$2,
		SpacingSquishSm: SpacingSquishSm$2,
		SpacingStackQuark: SpacingStackQuark$2,
		SpacingStackNano: SpacingStackNano$2,
		SpacingStackXxxs: SpacingStackXxxs$2,
		SpacingStackXxs: SpacingStackXxs$2,
		SpacingStackXs: SpacingStackXs$2,
		SpacingStackSm: SpacingStackSm$2,
		SpacingStackMd: SpacingStackMd$2,
		SpacingStackLg: SpacingStackLg$2,
		SpacingStackXl: SpacingStackXl$2,
		SpacingStackXxl: SpacingStackXxl$2,
		SpacingStackXxxl: SpacingStackXxxl$2,
		SpacingStackHuge: SpacingStackHuge$2,
		SpacingStackGiant: SpacingStackGiant$2,
		FontFamilyBase: FontFamilyBase$2,
		FontSizeXxxs: FontSizeXxxs$2,
		FontSizeXxs: FontSizeXxs$2,
		FontSizeXs: FontSizeXs$2,
		FontSizeSm: FontSizeSm$2,
		FontSizeMd: FontSizeMd$2,
		FontSizeLg: FontSizeLg$2,
		FontSizeXl: FontSizeXl$2,
		FontSizeXxl: FontSizeXxl$2,
		FontSizeXxxl: FontSizeXxxl$2,
		FontSizeDisplay: FontSizeDisplay$2,
		FontSizeGiant: FontSizeGiant$2,
		FontWeightBold: FontWeightBold$2,
		FontWeightSemibold: FontWeightSemibold$2,
		FontWeightMedium: FontWeightMedium$2,
		FontWeightRegular: FontWeightRegular$2,
		FontWeightLight: FontWeightLight$2,
		LetterSpacingStandard: LetterSpacingStandard$2,
		LetterSpacingSmall: LetterSpacingSmall$2,
		LetterSpacingMedium: LetterSpacingMedium$2,
		LineHeightStandard: LineHeightStandard$2,
		LineHeightTiny: LineHeightTiny$2,
		LineHeightMedium: LineHeightMedium$2,
		LineHeightLarge: LineHeightLarge$2,
		LineHeightDistant: LineHeightDistant$2,
		LineHeightSuperdistant: LineHeightSuperdistant$2,
		LineHeightHuge: LineHeightHuge$2
	});

	/**
	 * Do not edit directly
	 * Generated on Fri, 18 Feb 2022 15:26:43 GMT
	 */
	const BorderRadiusNone$1 = "0px";
	const BorderRadiusXs$1 = "4px";
	const BorderRadiusSm$1 = "8px";
	const BorderRadiusMd$1 = "16px";
	const BorderRadiusLg$1 = "24px";
	const BorderRadiusPill$1 = "960px";
	const BorderRadiusCircle$1 = "50%";
	const BorderWidthNone$1 = "0px";
	const BorderWidthHairline$1 = "1px";
	const BorderWidthThin$1 = "2px";
	const BorderWidthThick$1 = "4px";
	const BorderWidthHeavy$1 = "8px";
	const ColorDatavizNegativeText$1 = "#960012";
	const ColorDatavizNegativeShape01$1 = "#DA3347";
	const ColorDatavizNegativeShape02$1 = "#FFCCD2";
	const ColorDatavizNegativeShape03$1 = "#FFEDEF";
	const ColorDatavizPositiveText$1 = "#145528";
	const ColorDatavizPositiveShape01$1 = "#38BA5F";
	const ColorDatavizPositiveShape02$1 = "#C9EFD5";
	const ColorDatavizPositiveShape03$1 = "#EAF9EF";
	const ColorDatavizInverseNegativeText$1 = "#FFCCD2";
	const ColorDatavizInverseNegativeShape01$1 = "#F66778";
	const ColorDatavizInverseNegativeShape02$1 = "#AD1426";
	const ColorDatavizInverseNegativeShape03$1 = "#960012";
	const ColorDatavizInversePositiveText$1 = "#C9EFD5";
	const ColorDatavizInversePositiveShape01$1 = "#59D37E";
	const ColorDatavizInversePositiveShape02$1 = "#228340";
	const ColorDatavizInversePositiveShape03$1 = "#145528";
	const ColorInteractionBlend01$1 = "#1616160A";
	const ColorInteractionBlend02$1 = "#16161614";
	const ColorInteractionBlend03$1 = "#1616161F";
	const ColorInteractionBlend04$1 = "#1616163D";
	const ColorInteractionBlend05$1 = "#161616A3";
	const ColorInteractionBlend06$1 = "#161616B8";
	const ColorInteractionBlend07$1 = "#161616E0";
	const ColorInteractionBlend08$1 = "#161616";
	const ColorInteractionInverseBlend01$1 = "#FEFEFE14";
	const ColorInteractionInverseBlend02$1 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03$1 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04$1 = "#FEFEFE52";
	const ColorInteractionInverseBlend05$1 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06$1 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07$1 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08$1 = "#FEFEFE";
	const ColorInteractionInverseAccent01$1 = "#6D8DFF";
	const ColorInteractionInverseAccent02$1 = "#A0B5FF";
	const ColorInteractionInverseAccent03$1 = "#CCD7FF";
	const ColorInteractionInverseSubtle01$1 = "#6D8DFF1F";
	const ColorInteractionInverseSubtle02$1 = "#6D8DFF3D";
	const ColorInteractionInverseSubtle03$1 = "#6D8DFF52";
	const ColorInteractionInverseSelectDefault$1 = "#CCCCCC";
	const ColorInteractionInverseSelectFocus$1 = "#FEFEFE";
	const ColorInteractionInverseSelectActive$1 = "#CCD7FF";
	const ColorInteractionInverseDanger01$1 = "#F66778";
	const ColorInteractionInverseDanger02$1 = "#FF96A2";
	const ColorInteractionInverseDanger03$1 = "#FFCCD2";
	const ColorInteractionInverseOnBrandAccent01$1 = "#161616";
	const ColorInteractionInverseOnBrandAccent02$1 = "#161616E8";
	const ColorInteractionInverseOnBrandAccent03$1 = "#161616B8";
	const ColorInteractionInverseOnBrandSubtle01$1 = "#16161614";
	const ColorInteractionInverseOnBrandSubtle02$1 = "#1616161F";
	const ColorInteractionInverseOnBrandSubtle03$1 = "#1616163D";
	const ColorInteractionInverseOnBrandSelectDefault$1 = "#161616";
	const ColorInteractionInverseOnBrandSelectFocus$1 = "#161616";
	const ColorInteractionInverseOnBrandSelectActive$1 = "#161616";
	const ColorInteractionInverseOnBrandBlend01$1 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02$1 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03$1 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04$1 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05$1 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06$1 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07$1 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08$1 = "#161616";
	const ColorInteractionInverseOnBrandDanger01$1 = "#161616";
	const ColorInteractionInverseOnBrandDanger02$1 = "#161616E0";
	const ColorInteractionInverseOnBrandDanger03$1 = "#161616B8";
	const ColorInteractionAccent01$1 = "#0037FF";
	const ColorInteractionAccent02$1 = "#002FDA";
	const ColorInteractionAccent03$1 = "#0028B8";
	const ColorInteractionSubtle01$1 = "#0037FF1F";
	const ColorInteractionSubtle02$1 = "#0037FF3D";
	const ColorInteractionSubtle03$1 = "#0037FF52";
	const ColorInteractionSelectDefault$1 = "#4B4B4B";
	const ColorInteractionSelectFocus$1 = "#161616";
	const ColorInteractionSelectActive$1 = "#0028B8";
	const ColorInteractionDanger01$1 = "#DA3347";
	const ColorInteractionDanger02$1 = "#C62336";
	const ColorInteractionDanger03$1 = "#AD1426";
	const ColorInteractionOnBrandAccent01$1 = "#FEFEFE";
	const ColorInteractionOnBrandAccent02$1 = "#FEFEFEE0";
	const ColorInteractionOnBrandAccent03$1 = "#FEFEFEB8";
	const ColorInteractionOnBrandSubtle01$1 = "#FEFEFE1F";
	const ColorInteractionOnBrandSubtle02$1 = "#FEFEFE3D";
	const ColorInteractionOnBrandSubtle03$1 = "#FEFEFE52";
	const ColorInteractionOnBrandSelectDefault$1 = "#FEFEFE";
	const ColorInteractionOnBrandSelectFocus$1 = "#FEFEFE";
	const ColorInteractionOnBrandSelectActive$1 = "#FEFEFE";
	const ColorInteractionOnBrandBlend01$1 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02$1 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03$1 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04$1 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05$1 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06$1 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07$1 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08$1 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01$1 = "#FEFEFE";
	const ColorInteractionOnBrandDanger02$1 = "#FEFEFEE0";
	const ColorInteractionOnBrandDanger03$1 = "#FEFEFEB8";
	const ColorNeutral10$1 = "#F4F4F4";
	const ColorNeutral20$1 = "#E9E9E9";
	const ColorNeutral30$1 = "#1616161F";
	const ColorNeutral00$1 = "#FEFEFE";
	const ColorNeutralInverse10$1 = "#2B2B2B";
	const ColorNeutralInverse20$1 = "#323232";
	const ColorNeutralInverse30$1 = "#FEFEFE3D";
	const ColorNeutralInverse00$1 = "#161616";
	const ColorNeutralInverseOnBrand10$1 = "#002199";
	const ColorNeutralInverseOnBrand20$1 = "#0028B8";
	const ColorNeutralInverseOnBrand30$1 = "#0037FFE0";
	const ColorNeutralInverseOnBrand00$1 = "#161616";
	const ColorNeutralOnBrand10$1 = "#E6EBFF";
	const ColorNeutralOnBrand20$1 = "#CCD7FF";
	const ColorNeutralOnBrand30$1 = "#6D8DFFE0";
	const ColorNeutralOnBrand00$1 = "#FEFEFE";
	const ColorPaletteBlack$1 = "#161616";
	const ColorPaletteWhite$1 = "#FEFEFE";
	const ColorPaletteGray10$1 = "#2B2B2B";
	const ColorPaletteGray20$1 = "#323232";
	const ColorPaletteGray30$1 = "#4B4B4B";
	const ColorPaletteGray40$1 = "#606060";
	const ColorPaletteGray50$1 = "#B6B6B6";
	const ColorPaletteGray60$1 = "#CCCCCC";
	const ColorPaletteGray70$1 = "#E9E9E9";
	const ColorPaletteGray80$1 = "#F4F4F4";
	const ColorPaletteRed10$1 = "#960012";
	const ColorPaletteRed20$1 = "#AD1426";
	const ColorPaletteRed30$1 = "#C62336";
	const ColorPaletteRed40$1 = "#DA3347";
	const ColorPaletteRed50$1 = "#F66778";
	const ColorPaletteRed60$1 = "#FF96A2";
	const ColorPaletteRed70$1 = "#FFCCD2";
	const ColorPaletteRed80$1 = "#FFEDEF";
	const ColorPalettePurple10$1 = "#610F8A";
	const ColorPalettePurple20$1 = "#8214B8";
	const ColorPalettePurple30$1 = "#9818D9";
	const ColorPalettePurple40$1 = "#A93BDF";
	const ColorPalettePurple50$1 = "#C871F4";
	const ColorPalettePurple60$1 = "#DB9EFA";
	const ColorPalettePurple70$1 = "#EFD0FF";
	const ColorPalettePurple80$1 = "#FAF0FF";
	const ColorPaletteGreen10$1 = "#145528";
	const ColorPaletteGreen20$1 = "#228340";
	const ColorPaletteGreen30$1 = "#2DA853";
	const ColorPaletteGreen40$1 = "#38BA5F";
	const ColorPaletteGreen50$1 = "#59D37E";
	const ColorPaletteGreen60$1 = "#8AE3A5";
	const ColorPaletteGreen70$1 = "#C9EFD5";
	const ColorPaletteGreen80$1 = "#EAF9EF";
	const ColorPaletteYellow10$1 = "#8A6C0F";
	const ColorPaletteYellow20$1 = "#B88F14";
	const ColorPaletteYellow30$1 = "#E6B319";
	const ColorPaletteYellow40$1 = "#EBC247";
	const ColorPaletteYellow50$1 = "#F0D275";
	const ColorPaletteYellow60$1 = "#F5E1A3";
	const ColorPaletteYellow70$1 = "#FAF0D1";
	const ColorPaletteYellow80$1 = "#FDF8E8";
	const ColorTypefaceStrong$1 = "#161616";
	const ColorTypefacePure$1 = "#323232";
	const ColorTypefaceSmooth$1 = "#4B4B4B";
	const ColorTypefaceMeld$1 = "#1616163D";
	const ColorTypefaceInverseStrong$1 = "#FEFEFE";
	const ColorTypefaceInversePure$1 = "#E9E9E9";
	const ColorTypefaceInverseSmooth$1 = "#CCCCCC";
	const ColorTypefaceInverseMeld$1 = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong$1 = "#161616";
	const ColorTypefaceInverseOnBrandPure$1 = "#161616E0";
	const ColorTypefaceInverseOnBrandSmooth$1 = "#161616B8";
	const ColorTypefaceInverseOnBrandMeld$1 = "#1616163D";
	const ColorTypefaceOnBrandStrong$1 = "#FEFEFE";
	const ColorTypefaceOnBrandPure$1 = "#FEFEFEE0";
	const ColorTypefaceOnBrandSmooth$1 = "#FEFEFEB8";
	const ColorTypefaceOnBrandMeld$1 = "#FEFEFE52";
	const ColorBrandPrimary10$1 = "#002199";
	const ColorBrandPrimary20$1 = "#0028B8";
	const ColorBrandPrimary30$1 = "#002FDA";
	const ColorBrandPrimary40$1 = "#0037FF";
	const ColorBrandPrimary50$1 = "#6D8DFF";
	const ColorBrandPrimary60$1 = "#A0B5FF";
	const ColorBrandPrimary70$1 = "#CCD7FF";
	const ColorBrandPrimary80$1 = "#E6EBFF";
	const ColorFeedbackErrorText$1 = "#960012";
	const ColorFeedbackErrorShape$1 = "#DA3347";
	const ColorFeedbackSuccessText$1 = "#145528";
	const ColorFeedbackSuccessShape$1 = "#38BA5F";
	const ColorFeedbackOnBrandErrorText$1 = "#FEFEFE";
	const ColorFeedbackOnBrandErrorShape$1 = "#FEFEFEB8";
	const ColorFeedbackOnBrandSuccessText$1 = "#FEFEFE";
	const ColorFeedbackOnBrandSuccessShape$1 = "#FEFEFEB8";
	const ColorFeedbackInverseErrorText$1 = "#FFCCD2";
	const ColorFeedbackInverseErrorShape$1 = "#F66778";
	const ColorFeedbackInverseSuccessText$1 = "#C9EFD5";
	const ColorFeedbackInverseSuccessShape$1 = "#59D37E";
	const ColorFeedbackInverseOnBrandErrorText$1 = "#161616";
	const ColorFeedbackInverseOnBrandErrorShape$1 = "#161616B8";
	const ColorFeedbackInverseOnBrandSuccessText$1 = "#161616";
	const ColorFeedbackInverseOnBrandSuccessShape$1 = "#161616B8";
	const ColorIllustrationDeepBlue$1 = "#000F40";
	const ColorIllustrationNeonBlue$1 = "#0037FF";
	const ColorIllustrationNeonRed$1 = "#FF4F33";
	const ColorIllustrationClearBlue$1 = "#ABE6FF";
	const ColorIllustrationBiscuit$1 = "#D1B287";
	const ColorSupport01$1 = "#FF4E33";
	const ColorSupport02$1 = "#EC4A31";
	const ColorSupportOnBrand01$1 = "#E9FF66";
	const ColorSupportOnBrand02$1 = "#E9FF66";
	const ColorSupportInverse01$1 = "#FF4E33";
	const ColorSupportInverse02$1 = "#FF4E33";
	const ColorSupportInverseOnBrand01$1 = "#000F40";
	const ColorSupportInverseOnBrand02$1 = "#000F40";
	const Opacity01$1 = "0.04";
	const Opacity02$1 = "0.08";
	const Opacity03$1 = "0.12";
	const Opacity04$1 = "0.24";
	const Opacity05$1 = "0.32";
	const Opacity06$1 = "0.56";
	const Opacity07$1 = "0.64";
	const Opacity08$1 = "0.72";
	const Opacity09$1 = "0.88";
	const Shadow01$1 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02$1 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03$1 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04$1 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark$1 = "4px";
	const SpacingInlineNano$1 = "8px";
	const SpacingInlineXxxs$1 = "16px";
	const SpacingInlineXxs$1 = "24px";
	const SpacingInlineXs$1 = "32px";
	const SpacingInlineSm$1 = "40px";
	const SpacingInlineMd$1 = "48px";
	const SpacingInlineLg$1 = "56px";
	const SpacingInlineXl$1 = "64px";
	const SpacingInlineXxl$1 = "80px";
	const SpacingInlineXxxl$1 = "120px";
	const SpacingInlineHuge$1 = "160px";
	const SpacingInlineGiant$1 = "200px";
	const SpacingInsetQuark$1 = "4px";
	const SpacingInsetNano$1 = "8px";
	const SpacingInsetXs$1 = "16px";
	const SpacingInsetSm$1 = "24px";
	const SpacingInsetMd$1 = "32px";
	const SpacingInsetLg$1 = "40px";
	const SpacingSquishQuark$1 = "4px 8px";
	const SpacingSquishNano$1 = "8px 16px";
	const SpacingSquishXs$1 = "16px 24px";
	const SpacingSquishSm$1 = "16px 32px";
	const SpacingStackQuark$1 = "4px";
	const SpacingStackNano$1 = "8px";
	const SpacingStackXxxs$1 = "16px";
	const SpacingStackXxs$1 = "24px";
	const SpacingStackXs$1 = "32px";
	const SpacingStackSm$1 = "40px";
	const SpacingStackMd$1 = "48px";
	const SpacingStackLg$1 = "56px";
	const SpacingStackXl$1 = "64px";
	const SpacingStackXxl$1 = "80px";
	const SpacingStackXxxl$1 = "120px";
	const SpacingStackHuge$1 = "160px";
	const SpacingStackGiant$1 = "200px";
	const FontFamilyBase$1 = "'Dasa Sans', sans-serif";
	const FontSizeXxxs$1 = "0.75rem";
	const FontSizeXxs$1 = "0.875rem";
	const FontSizeXs$1 = "1rem";
	const FontSizeSm$1 = "1.25rem";
	const FontSizeMd$1 = "1.5rem";
	const FontSizeLg$1 = "2rem";
	const FontSizeXl$1 = "2.5rem";
	const FontSizeXxl$1 = "3rem";
	const FontSizeXxxl$1 = "4rem";
	const FontSizeDisplay$1 = "5rem";
	const FontSizeGiant$1 = "6rem";
	const FontWeightBold$1 = 700;
	const FontWeightSemibold$1 = 600;
	const FontWeightMedium$1 = 500;
	const FontWeightRegular$1 = 400;
	const FontWeightLight$1 = 300;
	const LetterSpacingStandard$1 = "0px";
	const LetterSpacingSmall$1 = "-1px";
	const LetterSpacingMedium$1 = "1.5px";
	const LineHeightStandard$1 = "100%";
	const LineHeightTiny$1 = "115%";
	const LineHeightMedium$1 = "120%";
	const LineHeightLarge$1 = "125%";
	const LineHeightDistant$1 = "133%";
	const LineHeightSuperdistant$1 = "150%";
	const LineHeightHuge$1 = "170%";

	var index$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone$1,
		BorderRadiusXs: BorderRadiusXs$1,
		BorderRadiusSm: BorderRadiusSm$1,
		BorderRadiusMd: BorderRadiusMd$1,
		BorderRadiusLg: BorderRadiusLg$1,
		BorderRadiusPill: BorderRadiusPill$1,
		BorderRadiusCircle: BorderRadiusCircle$1,
		BorderWidthNone: BorderWidthNone$1,
		BorderWidthHairline: BorderWidthHairline$1,
		BorderWidthThin: BorderWidthThin$1,
		BorderWidthThick: BorderWidthThick$1,
		BorderWidthHeavy: BorderWidthHeavy$1,
		ColorDatavizNegativeText: ColorDatavizNegativeText$1,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$1,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$1,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$1,
		ColorDatavizPositiveText: ColorDatavizPositiveText$1,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$1,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$1,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$1,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$1,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$1,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$1,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$1,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$1,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$1,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$1,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$1,
		ColorInteractionBlend01: ColorInteractionBlend01$1,
		ColorInteractionBlend02: ColorInteractionBlend02$1,
		ColorInteractionBlend03: ColorInteractionBlend03$1,
		ColorInteractionBlend04: ColorInteractionBlend04$1,
		ColorInteractionBlend05: ColorInteractionBlend05$1,
		ColorInteractionBlend06: ColorInteractionBlend06$1,
		ColorInteractionBlend07: ColorInteractionBlend07$1,
		ColorInteractionBlend08: ColorInteractionBlend08$1,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$1,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$1,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$1,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$1,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$1,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$1,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$1,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$1,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$1,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$1,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$1,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$1,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$1,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$1,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$1,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$1,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$1,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$1,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$1,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$1,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$1,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$1,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$1,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$1,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$1,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$1,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$1,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$1,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$1,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$1,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$1,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$1,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$1,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$1,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$1,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$1,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$1,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$1,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$1,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$1,
		ColorInteractionAccent01: ColorInteractionAccent01$1,
		ColorInteractionAccent02: ColorInteractionAccent02$1,
		ColorInteractionAccent03: ColorInteractionAccent03$1,
		ColorInteractionSubtle01: ColorInteractionSubtle01$1,
		ColorInteractionSubtle02: ColorInteractionSubtle02$1,
		ColorInteractionSubtle03: ColorInteractionSubtle03$1,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault$1,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus$1,
		ColorInteractionSelectActive: ColorInteractionSelectActive$1,
		ColorInteractionDanger01: ColorInteractionDanger01$1,
		ColorInteractionDanger02: ColorInteractionDanger02$1,
		ColorInteractionDanger03: ColorInteractionDanger03$1,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$1,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$1,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$1,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$1,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$1,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$1,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$1,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$1,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$1,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$1,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$1,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$1,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$1,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$1,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$1,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$1,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$1,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$1,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$1,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$1,
		ColorNeutral10: ColorNeutral10$1,
		ColorNeutral20: ColorNeutral20$1,
		ColorNeutral30: ColorNeutral30$1,
		ColorNeutral00: ColorNeutral00$1,
		ColorNeutralInverse10: ColorNeutralInverse10$1,
		ColorNeutralInverse20: ColorNeutralInverse20$1,
		ColorNeutralInverse30: ColorNeutralInverse30$1,
		ColorNeutralInverse00: ColorNeutralInverse00$1,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$1,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$1,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$1,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$1,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10$1,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20$1,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30$1,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00$1,
		ColorPaletteBlack: ColorPaletteBlack$1,
		ColorPaletteWhite: ColorPaletteWhite$1,
		ColorPaletteGray10: ColorPaletteGray10$1,
		ColorPaletteGray20: ColorPaletteGray20$1,
		ColorPaletteGray30: ColorPaletteGray30$1,
		ColorPaletteGray40: ColorPaletteGray40$1,
		ColorPaletteGray50: ColorPaletteGray50$1,
		ColorPaletteGray60: ColorPaletteGray60$1,
		ColorPaletteGray70: ColorPaletteGray70$1,
		ColorPaletteGray80: ColorPaletteGray80$1,
		ColorPaletteRed10: ColorPaletteRed10$1,
		ColorPaletteRed20: ColorPaletteRed20$1,
		ColorPaletteRed30: ColorPaletteRed30$1,
		ColorPaletteRed40: ColorPaletteRed40$1,
		ColorPaletteRed50: ColorPaletteRed50$1,
		ColorPaletteRed60: ColorPaletteRed60$1,
		ColorPaletteRed70: ColorPaletteRed70$1,
		ColorPaletteRed80: ColorPaletteRed80$1,
		ColorPalettePurple10: ColorPalettePurple10$1,
		ColorPalettePurple20: ColorPalettePurple20$1,
		ColorPalettePurple30: ColorPalettePurple30$1,
		ColorPalettePurple40: ColorPalettePurple40$1,
		ColorPalettePurple50: ColorPalettePurple50$1,
		ColorPalettePurple60: ColorPalettePurple60$1,
		ColorPalettePurple70: ColorPalettePurple70$1,
		ColorPalettePurple80: ColorPalettePurple80$1,
		ColorPaletteGreen10: ColorPaletteGreen10$1,
		ColorPaletteGreen20: ColorPaletteGreen20$1,
		ColorPaletteGreen30: ColorPaletteGreen30$1,
		ColorPaletteGreen40: ColorPaletteGreen40$1,
		ColorPaletteGreen50: ColorPaletteGreen50$1,
		ColorPaletteGreen60: ColorPaletteGreen60$1,
		ColorPaletteGreen70: ColorPaletteGreen70$1,
		ColorPaletteGreen80: ColorPaletteGreen80$1,
		ColorPaletteYellow10: ColorPaletteYellow10$1,
		ColorPaletteYellow20: ColorPaletteYellow20$1,
		ColorPaletteYellow30: ColorPaletteYellow30$1,
		ColorPaletteYellow40: ColorPaletteYellow40$1,
		ColorPaletteYellow50: ColorPaletteYellow50$1,
		ColorPaletteYellow60: ColorPaletteYellow60$1,
		ColorPaletteYellow70: ColorPaletteYellow70$1,
		ColorPaletteYellow80: ColorPaletteYellow80$1,
		ColorTypefaceStrong: ColorTypefaceStrong$1,
		ColorTypefacePure: ColorTypefacePure$1,
		ColorTypefaceSmooth: ColorTypefaceSmooth$1,
		ColorTypefaceMeld: ColorTypefaceMeld$1,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$1,
		ColorTypefaceInversePure: ColorTypefaceInversePure$1,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$1,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$1,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$1,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$1,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$1,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$1,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$1,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$1,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$1,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$1,
		ColorBrandPrimary10: ColorBrandPrimary10$1,
		ColorBrandPrimary20: ColorBrandPrimary20$1,
		ColorBrandPrimary30: ColorBrandPrimary30$1,
		ColorBrandPrimary40: ColorBrandPrimary40$1,
		ColorBrandPrimary50: ColorBrandPrimary50$1,
		ColorBrandPrimary60: ColorBrandPrimary60$1,
		ColorBrandPrimary70: ColorBrandPrimary70$1,
		ColorBrandPrimary80: ColorBrandPrimary80$1,
		ColorFeedbackErrorText: ColorFeedbackErrorText$1,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape$1,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText$1,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$1,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$1,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$1,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$1,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$1,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$1,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$1,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$1,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$1,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$1,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$1,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$1,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$1,
		ColorIllustrationDeepBlue: ColorIllustrationDeepBlue$1,
		ColorIllustrationNeonBlue: ColorIllustrationNeonBlue$1,
		ColorIllustrationNeonRed: ColorIllustrationNeonRed$1,
		ColorIllustrationClearBlue: ColorIllustrationClearBlue$1,
		ColorIllustrationBiscuit: ColorIllustrationBiscuit$1,
		ColorSupport01: ColorSupport01$1,
		ColorSupport02: ColorSupport02$1,
		ColorSupportOnBrand01: ColorSupportOnBrand01$1,
		ColorSupportOnBrand02: ColorSupportOnBrand02$1,
		ColorSupportInverse01: ColorSupportInverse01$1,
		ColorSupportInverse02: ColorSupportInverse02$1,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$1,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$1,
		Opacity01: Opacity01$1,
		Opacity02: Opacity02$1,
		Opacity03: Opacity03$1,
		Opacity04: Opacity04$1,
		Opacity05: Opacity05$1,
		Opacity06: Opacity06$1,
		Opacity07: Opacity07$1,
		Opacity08: Opacity08$1,
		Opacity09: Opacity09$1,
		Shadow01: Shadow01$1,
		Shadow02: Shadow02$1,
		Shadow03: Shadow03$1,
		Shadow04: Shadow04$1,
		SpacingInlineQuark: SpacingInlineQuark$1,
		SpacingInlineNano: SpacingInlineNano$1,
		SpacingInlineXxxs: SpacingInlineXxxs$1,
		SpacingInlineXxs: SpacingInlineXxs$1,
		SpacingInlineXs: SpacingInlineXs$1,
		SpacingInlineSm: SpacingInlineSm$1,
		SpacingInlineMd: SpacingInlineMd$1,
		SpacingInlineLg: SpacingInlineLg$1,
		SpacingInlineXl: SpacingInlineXl$1,
		SpacingInlineXxl: SpacingInlineXxl$1,
		SpacingInlineXxxl: SpacingInlineXxxl$1,
		SpacingInlineHuge: SpacingInlineHuge$1,
		SpacingInlineGiant: SpacingInlineGiant$1,
		SpacingInsetQuark: SpacingInsetQuark$1,
		SpacingInsetNano: SpacingInsetNano$1,
		SpacingInsetXs: SpacingInsetXs$1,
		SpacingInsetSm: SpacingInsetSm$1,
		SpacingInsetMd: SpacingInsetMd$1,
		SpacingInsetLg: SpacingInsetLg$1,
		SpacingSquishQuark: SpacingSquishQuark$1,
		SpacingSquishNano: SpacingSquishNano$1,
		SpacingSquishXs: SpacingSquishXs$1,
		SpacingSquishSm: SpacingSquishSm$1,
		SpacingStackQuark: SpacingStackQuark$1,
		SpacingStackNano: SpacingStackNano$1,
		SpacingStackXxxs: SpacingStackXxxs$1,
		SpacingStackXxs: SpacingStackXxs$1,
		SpacingStackXs: SpacingStackXs$1,
		SpacingStackSm: SpacingStackSm$1,
		SpacingStackMd: SpacingStackMd$1,
		SpacingStackLg: SpacingStackLg$1,
		SpacingStackXl: SpacingStackXl$1,
		SpacingStackXxl: SpacingStackXxl$1,
		SpacingStackXxxl: SpacingStackXxxl$1,
		SpacingStackHuge: SpacingStackHuge$1,
		SpacingStackGiant: SpacingStackGiant$1,
		FontFamilyBase: FontFamilyBase$1,
		FontSizeXxxs: FontSizeXxxs$1,
		FontSizeXxs: FontSizeXxs$1,
		FontSizeXs: FontSizeXs$1,
		FontSizeSm: FontSizeSm$1,
		FontSizeMd: FontSizeMd$1,
		FontSizeLg: FontSizeLg$1,
		FontSizeXl: FontSizeXl$1,
		FontSizeXxl: FontSizeXxl$1,
		FontSizeXxxl: FontSizeXxxl$1,
		FontSizeDisplay: FontSizeDisplay$1,
		FontSizeGiant: FontSizeGiant$1,
		FontWeightBold: FontWeightBold$1,
		FontWeightSemibold: FontWeightSemibold$1,
		FontWeightMedium: FontWeightMedium$1,
		FontWeightRegular: FontWeightRegular$1,
		FontWeightLight: FontWeightLight$1,
		LetterSpacingStandard: LetterSpacingStandard$1,
		LetterSpacingSmall: LetterSpacingSmall$1,
		LetterSpacingMedium: LetterSpacingMedium$1,
		LineHeightStandard: LineHeightStandard$1,
		LineHeightTiny: LineHeightTiny$1,
		LineHeightMedium: LineHeightMedium$1,
		LineHeightLarge: LineHeightLarge$1,
		LineHeightDistant: LineHeightDistant$1,
		LineHeightSuperdistant: LineHeightSuperdistant$1,
		LineHeightHuge: LineHeightHuge$1
	});

	/**
	 * Do not edit directly
	 * Generated on Fri, 18 Feb 2022 15:26:43 GMT
	 */
	const BorderRadiusNone = "0px";
	const BorderRadiusXs = "4px";
	const BorderRadiusSm = "8px";
	const BorderRadiusMd = "16px";
	const BorderRadiusLg = "24px";
	const BorderRadiusPill = "960px";
	const BorderRadiusCircle = "50%";
	const BorderWidthNone = "0px";
	const BorderWidthHairline = "1px";
	const BorderWidthThin = "2px";
	const BorderWidthThick = "4px";
	const BorderWidthHeavy = "8px";
	const ColorDatavizNegativeText = "#960012";
	const ColorDatavizNegativeShape01 = "#DA3347";
	const ColorDatavizNegativeShape02 = "#FFCCD2";
	const ColorDatavizNegativeShape03 = "#FFEDEF";
	const ColorDatavizPositiveText = "#145528";
	const ColorDatavizPositiveShape01 = "#38BA5F";
	const ColorDatavizPositiveShape02 = "#C9EFD5";
	const ColorDatavizPositiveShape03 = "#EAF9EF";
	const ColorDatavizInverseNegativeText = "#FFCCD2";
	const ColorDatavizInverseNegativeShape01 = "#F66778";
	const ColorDatavizInverseNegativeShape02 = "#AD1426";
	const ColorDatavizInverseNegativeShape03 = "#960012";
	const ColorDatavizInversePositiveText = "#C9EFD5";
	const ColorDatavizInversePositiveShape01 = "#59D37E";
	const ColorDatavizInversePositiveShape02 = "#228340";
	const ColorDatavizInversePositiveShape03 = "#145528";
	const ColorInteractionBlend01 = "#1616160A";
	const ColorInteractionBlend02 = "#16161614";
	const ColorInteractionBlend03 = "#1616161F";
	const ColorInteractionBlend04 = "#1616163D";
	const ColorInteractionBlend05 = "#161616A3";
	const ColorInteractionBlend06 = "#161616B8";
	const ColorInteractionBlend07 = "#161616E0";
	const ColorInteractionBlend08 = "#161616";
	const ColorInteractionInverseBlend01 = "#FEFEFE14";
	const ColorInteractionInverseBlend02 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04 = "#FEFEFE52";
	const ColorInteractionInverseBlend05 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08 = "#FEFEFE";
	const ColorInteractionInverseAccent01 = "#6D8DFF";
	const ColorInteractionInverseAccent02 = "#A0B5FF";
	const ColorInteractionInverseAccent03 = "#CCD7FF";
	const ColorInteractionInverseSubtle01 = "#6D8DFF1F";
	const ColorInteractionInverseSubtle02 = "#6D8DFF3D";
	const ColorInteractionInverseSubtle03 = "#6D8DFF52";
	const ColorInteractionInverseSelectDefault = "#CCCCCC";
	const ColorInteractionInverseSelectFocus = "#FEFEFE";
	const ColorInteractionInverseSelectActive = "#CCD7FF";
	const ColorInteractionInverseDanger01 = "#F66778";
	const ColorInteractionInverseDanger02 = "#FF96A2";
	const ColorInteractionInverseDanger03 = "#FFCCD2";
	const ColorInteractionInverseOnBrandAccent01 = "#161616";
	const ColorInteractionInverseOnBrandAccent02 = "#161616E8";
	const ColorInteractionInverseOnBrandAccent03 = "#161616B8";
	const ColorInteractionInverseOnBrandSubtle01 = "#16161614";
	const ColorInteractionInverseOnBrandSubtle02 = "#1616161F";
	const ColorInteractionInverseOnBrandSubtle03 = "#1616163D";
	const ColorInteractionInverseOnBrandSelectDefault = "#161616";
	const ColorInteractionInverseOnBrandSelectFocus = "#161616";
	const ColorInteractionInverseOnBrandSelectActive = "#161616";
	const ColorInteractionInverseOnBrandBlend01 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08 = "#161616";
	const ColorInteractionInverseOnBrandDanger01 = "#161616";
	const ColorInteractionInverseOnBrandDanger02 = "#161616E0";
	const ColorInteractionInverseOnBrandDanger03 = "#161616B8";
	const ColorInteractionAccent01 = "#0037FF";
	const ColorInteractionAccent02 = "#002FDA";
	const ColorInteractionAccent03 = "#0028B8";
	const ColorInteractionSubtle01 = "#0037FF1F";
	const ColorInteractionSubtle02 = "#0037FF3D";
	const ColorInteractionSubtle03 = "#0037FF52";
	const ColorInteractionSelectDefault = "#4B4B4B";
	const ColorInteractionSelectFocus = "#161616";
	const ColorInteractionSelectActive = "#0028B8";
	const ColorInteractionDanger01 = "#DA3347";
	const ColorInteractionDanger02 = "#C62336";
	const ColorInteractionDanger03 = "#AD1426";
	const ColorInteractionOnBrandAccent01 = "#FEFEFE";
	const ColorInteractionOnBrandAccent02 = "#FEFEFEE0";
	const ColorInteractionOnBrandAccent03 = "#FEFEFEB8";
	const ColorInteractionOnBrandSubtle01 = "#FEFEFE1F";
	const ColorInteractionOnBrandSubtle02 = "#FEFEFE3D";
	const ColorInteractionOnBrandSubtle03 = "#FEFEFE52";
	const ColorInteractionOnBrandSelectDefault = "#FEFEFE";
	const ColorInteractionOnBrandSelectFocus = "#FEFEFE";
	const ColorInteractionOnBrandSelectActive = "#FEFEFE";
	const ColorInteractionOnBrandBlend01 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01 = "#FEFEFE";
	const ColorInteractionOnBrandDanger02 = "#FEFEFEE0";
	const ColorInteractionOnBrandDanger03 = "#FEFEFEB8";
	const ColorNeutral10 = "#F4F4F4";
	const ColorNeutral20 = "#E9E9E9";
	const ColorNeutral30 = "#1616161F";
	const ColorNeutral00 = "#FEFEFE";
	const ColorNeutralInverse10 = "#2B2B2B";
	const ColorNeutralInverse20 = "#323232";
	const ColorNeutralInverse30 = "#FEFEFE3D";
	const ColorNeutralInverse00 = "#161616";
	const ColorNeutralInverseOnBrand10 = "#002199";
	const ColorNeutralInverseOnBrand20 = "#0028B8";
	const ColorNeutralInverseOnBrand30 = "#0037FFE0";
	const ColorNeutralInverseOnBrand00 = "#161616";
	const ColorNeutralOnBrand10 = "#E6EBFF";
	const ColorNeutralOnBrand20 = "#CCD7FF";
	const ColorNeutralOnBrand30 = "#6D8DFFE0";
	const ColorNeutralOnBrand00 = "#FEFEFE";
	const ColorPaletteBlack = "#161616";
	const ColorPaletteWhite = "#FEFEFE";
	const ColorPaletteGray10 = "#2B2B2B";
	const ColorPaletteGray20 = "#323232";
	const ColorPaletteGray30 = "#4B4B4B";
	const ColorPaletteGray40 = "#606060";
	const ColorPaletteGray50 = "#B6B6B6";
	const ColorPaletteGray60 = "#CCCCCC";
	const ColorPaletteGray70 = "#E9E9E9";
	const ColorPaletteGray80 = "#F4F4F4";
	const ColorPaletteRed10 = "#960012";
	const ColorPaletteRed20 = "#AD1426";
	const ColorPaletteRed30 = "#C62336";
	const ColorPaletteRed40 = "#DA3347";
	const ColorPaletteRed50 = "#F66778";
	const ColorPaletteRed60 = "#FF96A2";
	const ColorPaletteRed70 = "#FFCCD2";
	const ColorPaletteRed80 = "#FFEDEF";
	const ColorPalettePurple10 = "#610F8A";
	const ColorPalettePurple20 = "#8214B8";
	const ColorPalettePurple30 = "#9818D9";
	const ColorPalettePurple40 = "#A93BDF";
	const ColorPalettePurple50 = "#C871F4";
	const ColorPalettePurple60 = "#DB9EFA";
	const ColorPalettePurple70 = "#EFD0FF";
	const ColorPalettePurple80 = "#FAF0FF";
	const ColorPaletteGreen10 = "#145528";
	const ColorPaletteGreen20 = "#228340";
	const ColorPaletteGreen30 = "#2DA853";
	const ColorPaletteGreen40 = "#38BA5F";
	const ColorPaletteGreen50 = "#59D37E";
	const ColorPaletteGreen60 = "#8AE3A5";
	const ColorPaletteGreen70 = "#C9EFD5";
	const ColorPaletteGreen80 = "#EAF9EF";
	const ColorPaletteYellow10 = "#8A6C0F";
	const ColorPaletteYellow20 = "#B88F14";
	const ColorPaletteYellow30 = "#E6B319";
	const ColorPaletteYellow40 = "#EBC247";
	const ColorPaletteYellow50 = "#F0D275";
	const ColorPaletteYellow60 = "#F5E1A3";
	const ColorPaletteYellow70 = "#FAF0D1";
	const ColorPaletteYellow80 = "#FDF8E8";
	const ColorTypefaceStrong = "#161616";
	const ColorTypefacePure = "#323232";
	const ColorTypefaceSmooth = "#4B4B4B";
	const ColorTypefaceMeld = "#1616163D";
	const ColorTypefaceInverseStrong = "#FEFEFE";
	const ColorTypefaceInversePure = "#E9E9E9";
	const ColorTypefaceInverseSmooth = "#CCCCCC";
	const ColorTypefaceInverseMeld = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong = "#161616";
	const ColorTypefaceInverseOnBrandPure = "#161616E0";
	const ColorTypefaceInverseOnBrandSmooth = "#161616B8";
	const ColorTypefaceInverseOnBrandMeld = "#1616163D";
	const ColorTypefaceOnBrandStrong = "#FEFEFE";
	const ColorTypefaceOnBrandPure = "#FEFEFEE0";
	const ColorTypefaceOnBrandSmooth = "#FEFEFEB8";
	const ColorTypefaceOnBrandMeld = "#FEFEFE52";
	const ColorBrandPrimary10 = "#002199";
	const ColorBrandPrimary20 = "#0028B8";
	const ColorBrandPrimary30 = "#002FDA";
	const ColorBrandPrimary40 = "#0037FF";
	const ColorBrandPrimary50 = "#6D8DFF";
	const ColorBrandPrimary60 = "#A0B5FF";
	const ColorBrandPrimary70 = "#CCD7FF";
	const ColorBrandPrimary80 = "#E6EBFF";
	const ColorFeedbackErrorText = "#960012";
	const ColorFeedbackErrorShape = "#DA3347";
	const ColorFeedbackSuccessText = "#145528";
	const ColorFeedbackSuccessShape = "#38BA5F";
	const ColorFeedbackOnBrandErrorText = "#FEFEFE";
	const ColorFeedbackOnBrandErrorShape = "#FEFEFEB8";
	const ColorFeedbackOnBrandSuccessText = "#FEFEFE";
	const ColorFeedbackOnBrandSuccessShape = "#FEFEFEB8";
	const ColorFeedbackInverseErrorText = "#FFCCD2";
	const ColorFeedbackInverseErrorShape = "#F66778";
	const ColorFeedbackInverseSuccessText = "#C9EFD5";
	const ColorFeedbackInverseSuccessShape = "#59D37E";
	const ColorFeedbackInverseOnBrandErrorText = "#161616";
	const ColorFeedbackInverseOnBrandErrorShape = "#161616B8";
	const ColorFeedbackInverseOnBrandSuccessText = "#161616";
	const ColorFeedbackInverseOnBrandSuccessShape = "#161616B8";
	const ColorIllustrationDeepBlue = "#000F40";
	const ColorIllustrationNeonBlue = "#0037FF";
	const ColorIllustrationNeonRed = "#FF4F33";
	const ColorIllustrationClearBlue = "#ABE6FF";
	const ColorIllustrationBiscuit = "#D1B287";
	const ColorSupport01 = "#FF4E33";
	const ColorSupport02 = "#EC4A31";
	const ColorSupportOnBrand01 = "#E9FF66";
	const ColorSupportOnBrand02 = "#E9FF66";
	const ColorSupportInverse01 = "#FF4E33";
	const ColorSupportInverse02 = "#FF4E33";
	const ColorSupportInverseOnBrand01 = "#000F40";
	const ColorSupportInverseOnBrand02 = "#000F40";
	const Opacity01 = "0.04";
	const Opacity02 = "0.08";
	const Opacity03 = "0.12";
	const Opacity04 = "0.24";
	const Opacity05 = "0.32";
	const Opacity06 = "0.56";
	const Opacity07 = "0.64";
	const Opacity08 = "0.72";
	const Opacity09 = "0.88";
	const Shadow01 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark = "4px";
	const SpacingInlineNano = "8px";
	const SpacingInlineXxxs = "16px";
	const SpacingInlineXxs = "24px";
	const SpacingInlineXs = "32px";
	const SpacingInlineSm = "40px";
	const SpacingInlineMd = "48px";
	const SpacingInlineLg = "56px";
	const SpacingInlineXl = "64px";
	const SpacingInlineXxl = "80px";
	const SpacingInlineXxxl = "120px";
	const SpacingInlineHuge = "160px";
	const SpacingInlineGiant = "200px";
	const SpacingInsetQuark = "4px";
	const SpacingInsetNano = "8px";
	const SpacingInsetXs = "16px";
	const SpacingInsetSm = "24px";
	const SpacingInsetMd = "32px";
	const SpacingInsetLg = "40px";
	const SpacingSquishQuark = "4px 8px";
	const SpacingSquishNano = "8px 16px";
	const SpacingSquishXs = "16px 24px";
	const SpacingSquishSm = "16px 32px";
	const SpacingStackQuark = "4px";
	const SpacingStackNano = "8px";
	const SpacingStackXxxs = "16px";
	const SpacingStackXxs = "24px";
	const SpacingStackXs = "32px";
	const SpacingStackSm = "40px";
	const SpacingStackMd = "48px";
	const SpacingStackLg = "56px";
	const SpacingStackXl = "64px";
	const SpacingStackXxl = "80px";
	const SpacingStackXxxl = "120px";
	const SpacingStackHuge = "160px";
	const SpacingStackGiant = "200px";
	const FontFamilyBase = "'Dasa Sans', sans-serif";
	const FontSizeXxxs = "12px";
	const FontSizeXxs = "14px";
	const FontSizeXs = "16px";
	const FontSizeSm = "20px";
	const FontSizeMd = "24px";
	const FontSizeLg = "32px";
	const FontSizeXl = "40px";
	const FontSizeXxl = "48px";
	const FontSizeXxxl = "64px";
	const FontSizeDisplay = "80px";
	const FontSizeGiant = "96px";
	const FontWeightBold = 700;
	const FontWeightSemibold = 600;
	const FontWeightMedium = 500;
	const FontWeightRegular = 400;
	const FontWeightLight = 300;
	const LetterSpacingStandard = "0px";
	const LetterSpacingSmall = "-1px";
	const LetterSpacingMedium = "1.5px";
	const LineHeightStandard = "100%";
	const LineHeightTiny = "115%";
	const LineHeightMedium = "120%";
	const LineHeightLarge = "125%";
	const LineHeightDistant = "133%";
	const LineHeightSuperdistant = "150%";
	const LineHeightHuge = "170%";
	const LineHeightXxs = "12px";
	const LineHeightXs = "16px";
	const LineHeightSm = "24px";
	const LineHeightMd = "32px";
	const LineHeightLg = "40px";
	const LineHeightXl = "48px";
	const LineHeightXxl = "56px";
	const LineHeightXxxl = "64px";

	var index = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone,
		BorderRadiusXs: BorderRadiusXs,
		BorderRadiusSm: BorderRadiusSm,
		BorderRadiusMd: BorderRadiusMd,
		BorderRadiusLg: BorderRadiusLg,
		BorderRadiusPill: BorderRadiusPill,
		BorderRadiusCircle: BorderRadiusCircle,
		BorderWidthNone: BorderWidthNone,
		BorderWidthHairline: BorderWidthHairline,
		BorderWidthThin: BorderWidthThin,
		BorderWidthThick: BorderWidthThick,
		BorderWidthHeavy: BorderWidthHeavy,
		ColorDatavizNegativeText: ColorDatavizNegativeText,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03,
		ColorDatavizPositiveText: ColorDatavizPositiveText,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03,
		ColorInteractionBlend01: ColorInteractionBlend01,
		ColorInteractionBlend02: ColorInteractionBlend02,
		ColorInteractionBlend03: ColorInteractionBlend03,
		ColorInteractionBlend04: ColorInteractionBlend04,
		ColorInteractionBlend05: ColorInteractionBlend05,
		ColorInteractionBlend06: ColorInteractionBlend06,
		ColorInteractionBlend07: ColorInteractionBlend07,
		ColorInteractionBlend08: ColorInteractionBlend08,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03,
		ColorInteractionAccent01: ColorInteractionAccent01,
		ColorInteractionAccent02: ColorInteractionAccent02,
		ColorInteractionAccent03: ColorInteractionAccent03,
		ColorInteractionSubtle01: ColorInteractionSubtle01,
		ColorInteractionSubtle02: ColorInteractionSubtle02,
		ColorInteractionSubtle03: ColorInteractionSubtle03,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus,
		ColorInteractionSelectActive: ColorInteractionSelectActive,
		ColorInteractionDanger01: ColorInteractionDanger01,
		ColorInteractionDanger02: ColorInteractionDanger02,
		ColorInteractionDanger03: ColorInteractionDanger03,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03,
		ColorNeutral10: ColorNeutral10,
		ColorNeutral20: ColorNeutral20,
		ColorNeutral30: ColorNeutral30,
		ColorNeutral00: ColorNeutral00,
		ColorNeutralInverse10: ColorNeutralInverse10,
		ColorNeutralInverse20: ColorNeutralInverse20,
		ColorNeutralInverse30: ColorNeutralInverse30,
		ColorNeutralInverse00: ColorNeutralInverse00,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00,
		ColorPaletteBlack: ColorPaletteBlack,
		ColorPaletteWhite: ColorPaletteWhite,
		ColorPaletteGray10: ColorPaletteGray10,
		ColorPaletteGray20: ColorPaletteGray20,
		ColorPaletteGray30: ColorPaletteGray30,
		ColorPaletteGray40: ColorPaletteGray40,
		ColorPaletteGray50: ColorPaletteGray50,
		ColorPaletteGray60: ColorPaletteGray60,
		ColorPaletteGray70: ColorPaletteGray70,
		ColorPaletteGray80: ColorPaletteGray80,
		ColorPaletteRed10: ColorPaletteRed10,
		ColorPaletteRed20: ColorPaletteRed20,
		ColorPaletteRed30: ColorPaletteRed30,
		ColorPaletteRed40: ColorPaletteRed40,
		ColorPaletteRed50: ColorPaletteRed50,
		ColorPaletteRed60: ColorPaletteRed60,
		ColorPaletteRed70: ColorPaletteRed70,
		ColorPaletteRed80: ColorPaletteRed80,
		ColorPalettePurple10: ColorPalettePurple10,
		ColorPalettePurple20: ColorPalettePurple20,
		ColorPalettePurple30: ColorPalettePurple30,
		ColorPalettePurple40: ColorPalettePurple40,
		ColorPalettePurple50: ColorPalettePurple50,
		ColorPalettePurple60: ColorPalettePurple60,
		ColorPalettePurple70: ColorPalettePurple70,
		ColorPalettePurple80: ColorPalettePurple80,
		ColorPaletteGreen10: ColorPaletteGreen10,
		ColorPaletteGreen20: ColorPaletteGreen20,
		ColorPaletteGreen30: ColorPaletteGreen30,
		ColorPaletteGreen40: ColorPaletteGreen40,
		ColorPaletteGreen50: ColorPaletteGreen50,
		ColorPaletteGreen60: ColorPaletteGreen60,
		ColorPaletteGreen70: ColorPaletteGreen70,
		ColorPaletteGreen80: ColorPaletteGreen80,
		ColorPaletteYellow10: ColorPaletteYellow10,
		ColorPaletteYellow20: ColorPaletteYellow20,
		ColorPaletteYellow30: ColorPaletteYellow30,
		ColorPaletteYellow40: ColorPaletteYellow40,
		ColorPaletteYellow50: ColorPaletteYellow50,
		ColorPaletteYellow60: ColorPaletteYellow60,
		ColorPaletteYellow70: ColorPaletteYellow70,
		ColorPaletteYellow80: ColorPaletteYellow80,
		ColorTypefaceStrong: ColorTypefaceStrong,
		ColorTypefacePure: ColorTypefacePure,
		ColorTypefaceSmooth: ColorTypefaceSmooth,
		ColorTypefaceMeld: ColorTypefaceMeld,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong,
		ColorTypefaceInversePure: ColorTypefaceInversePure,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld,
		ColorBrandPrimary10: ColorBrandPrimary10,
		ColorBrandPrimary20: ColorBrandPrimary20,
		ColorBrandPrimary30: ColorBrandPrimary30,
		ColorBrandPrimary40: ColorBrandPrimary40,
		ColorBrandPrimary50: ColorBrandPrimary50,
		ColorBrandPrimary60: ColorBrandPrimary60,
		ColorBrandPrimary70: ColorBrandPrimary70,
		ColorBrandPrimary80: ColorBrandPrimary80,
		ColorFeedbackErrorText: ColorFeedbackErrorText,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape,
		ColorIllustrationDeepBlue: ColorIllustrationDeepBlue,
		ColorIllustrationNeonBlue: ColorIllustrationNeonBlue,
		ColorIllustrationNeonRed: ColorIllustrationNeonRed,
		ColorIllustrationClearBlue: ColorIllustrationClearBlue,
		ColorIllustrationBiscuit: ColorIllustrationBiscuit,
		ColorSupport01: ColorSupport01,
		ColorSupport02: ColorSupport02,
		ColorSupportOnBrand01: ColorSupportOnBrand01,
		ColorSupportOnBrand02: ColorSupportOnBrand02,
		ColorSupportInverse01: ColorSupportInverse01,
		ColorSupportInverse02: ColorSupportInverse02,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02,
		Opacity01: Opacity01,
		Opacity02: Opacity02,
		Opacity03: Opacity03,
		Opacity04: Opacity04,
		Opacity05: Opacity05,
		Opacity06: Opacity06,
		Opacity07: Opacity07,
		Opacity08: Opacity08,
		Opacity09: Opacity09,
		Shadow01: Shadow01,
		Shadow02: Shadow02,
		Shadow03: Shadow03,
		Shadow04: Shadow04,
		SpacingInlineQuark: SpacingInlineQuark,
		SpacingInlineNano: SpacingInlineNano,
		SpacingInlineXxxs: SpacingInlineXxxs,
		SpacingInlineXxs: SpacingInlineXxs,
		SpacingInlineXs: SpacingInlineXs,
		SpacingInlineSm: SpacingInlineSm,
		SpacingInlineMd: SpacingInlineMd,
		SpacingInlineLg: SpacingInlineLg,
		SpacingInlineXl: SpacingInlineXl,
		SpacingInlineXxl: SpacingInlineXxl,
		SpacingInlineXxxl: SpacingInlineXxxl,
		SpacingInlineHuge: SpacingInlineHuge,
		SpacingInlineGiant: SpacingInlineGiant,
		SpacingInsetQuark: SpacingInsetQuark,
		SpacingInsetNano: SpacingInsetNano,
		SpacingInsetXs: SpacingInsetXs,
		SpacingInsetSm: SpacingInsetSm,
		SpacingInsetMd: SpacingInsetMd,
		SpacingInsetLg: SpacingInsetLg,
		SpacingSquishQuark: SpacingSquishQuark,
		SpacingSquishNano: SpacingSquishNano,
		SpacingSquishXs: SpacingSquishXs,
		SpacingSquishSm: SpacingSquishSm,
		SpacingStackQuark: SpacingStackQuark,
		SpacingStackNano: SpacingStackNano,
		SpacingStackXxxs: SpacingStackXxxs,
		SpacingStackXxs: SpacingStackXxs,
		SpacingStackXs: SpacingStackXs,
		SpacingStackSm: SpacingStackSm,
		SpacingStackMd: SpacingStackMd,
		SpacingStackLg: SpacingStackLg,
		SpacingStackXl: SpacingStackXl,
		SpacingStackXxl: SpacingStackXxl,
		SpacingStackXxxl: SpacingStackXxxl,
		SpacingStackHuge: SpacingStackHuge,
		SpacingStackGiant: SpacingStackGiant,
		FontFamilyBase: FontFamilyBase,
		FontSizeXxxs: FontSizeXxxs,
		FontSizeXxs: FontSizeXxs,
		FontSizeXs: FontSizeXs,
		FontSizeSm: FontSizeSm,
		FontSizeMd: FontSizeMd,
		FontSizeLg: FontSizeLg,
		FontSizeXl: FontSizeXl,
		FontSizeXxl: FontSizeXxl,
		FontSizeXxxl: FontSizeXxxl,
		FontSizeDisplay: FontSizeDisplay,
		FontSizeGiant: FontSizeGiant,
		FontWeightBold: FontWeightBold,
		FontWeightSemibold: FontWeightSemibold,
		FontWeightMedium: FontWeightMedium,
		FontWeightRegular: FontWeightRegular,
		FontWeightLight: FontWeightLight,
		LetterSpacingStandard: LetterSpacingStandard,
		LetterSpacingSmall: LetterSpacingSmall,
		LetterSpacingMedium: LetterSpacingMedium,
		LineHeightStandard: LineHeightStandard,
		LineHeightTiny: LineHeightTiny,
		LineHeightMedium: LineHeightMedium,
		LineHeightLarge: LineHeightLarge,
		LineHeightDistant: LineHeightDistant,
		LineHeightSuperdistant: LineHeightSuperdistant,
		LineHeightHuge: LineHeightHuge,
		LineHeightXxs: LineHeightXxs,
		LineHeightXs: LineHeightXs,
		LineHeightSm: LineHeightSm,
		LineHeightMd: LineHeightMd,
		LineHeightLg: LineHeightLg,
		LineHeightXl: LineHeightXl,
		LineHeightXxl: LineHeightXxl,
		LineHeightXxxl: LineHeightXxxl
	});

	exports.almTokens = index$3;
	exports.dasTokens = index$2;
	exports.navMobTokens = index;
	exports.navTokens = index$1;

	Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.umd.js.map
